// Auto-generated from supported-crypto-asset.xlsx
export const supportedAssets = [
  { id: '0G-1769', symbol: '0G', name: '0G', network: 'Other' },
  { id: '1INCH-4', symbol: '1INCH', name: '1inch Network', network: 'Other' },
  { id: '1MBABYDOGE-5', symbol: '1MBABYDOGE', name: '1MBABYDOGE', network: 'Other' },
  { id: '2Z-1773', symbol: '2Z', name: 'DoubleZero', network: 'Other' },
  { id: 'A-1446', symbol: 'A', name: 'Vaulta', network: 'Other' },
  { id: 'A2Z-1529', symbol: 'A2Z', name: 'Arena-Z', network: 'Other' },
  { id: 'A47-1554', symbol: 'A47', name: 'AGENDA 47', network: 'Other' },
  { id: 'A8-68', symbol: 'A8', name: 'Ancient8', network: 'Other' },
  { id: 'AAPLON-1933', symbol: 'AAPLON', name: 'Apple Tokenized Stock (Ondo)', network: 'Other' },
  { id: 'AAPLX-1531', symbol: 'AAPLX', name: 'Apple tokenized stock', network: 'Other' },
  { id: 'AAVE-9', symbol: 'AAVE', name: 'Aave', network: 'Other' },
  { id: 'AB-1448', symbol: 'AB', name: 'AB', network: 'Other' },
  { id: 'ABBVX-1961', symbol: 'ABBVX', name: 'AbbVie Tokenized Stock (xStock)', network: 'Other' },
  { id: 'ABTON-1956', symbol: 'ABTON', name: 'Abbott Tokenized Stock (Ondo)', network: 'Other' },
  { id: 'ACA-14', symbol: 'ACA', name: 'Acala Token', network: 'Other' },
  { id: 'ACE-461', symbol: 'ACE', name: 'Fusionist', network: 'Other' },
  { id: 'ACH-42', symbol: 'ACH', name: 'Alchemy Pay', network: 'Other' },
  { id: 'ACM-13', symbol: 'ACM', name: 'AC Milan Fan Token', network: 'Other' },
  { id: 'ACNON-1950', symbol: 'ACNON', name: 'Accenture Tokenized Stock (Ondo)', network: 'Other' },
  { id: 'ACS-15', symbol: 'ACS', name: 'Access Protocol', network: 'Other' },
  { id: 'ACT-18', symbol: 'ACT', name: 'Act I : The AI Prophecy', network: 'Other' },
  { id: 'ACX-17', symbol: 'ACX', name: 'Across Protocol', network: 'Other' },
  { id: 'ADA-221', symbol: 'ADA', name: 'Cardano', network: 'Other' },
  { id: 'ADP-19', symbol: 'ADP', name: 'Adappter Token', network: 'Other' },
  { id: 'ADX-21', symbol: 'ADX', name: 'AdEx', network: 'Other' },
  { id: 'AERGO-24', symbol: 'AERGO', name: 'Aergo', network: 'Other' },
  { id: 'AERO-25', symbol: 'AERO', name: 'Aerodrome Finance', network: 'Other' },
  { id: 'AEUR-67', symbol: 'AEUR', name: 'Anchored Coins', network: 'Other' },
  { id: 'AEVO-28', symbol: 'AEVO', name: 'Aevo', network: 'Other' },
  { id: 'AFC-95', symbol: 'AFC', name: 'Arsenal Fan Token', network: 'Other' },
  { id: 'AGGON-1921', symbol: 'AGGON', name: 'iShares Core US Aggregate Bond Tokenized ETF (Ondo)', network: 'Other' },
  { id: 'AGI-340', symbol: 'AGI', name: 'Delysium', network: 'Other' },
  { id: 'AGLD-22', symbol: 'AGLD', name: 'Adventure Gold', network: 'Other' },
  { id: 'AGT-1685', symbol: 'AGT', name: 'Alaya Governance Token', network: 'Other' },
  { id: 'AI-1080', symbol: 'AI', name: 'Sleepless AI', network: 'Other' },
  { id: 'AI3-1693', symbol: 'AI3', name: 'Autonomys Network', network: 'Other' },
  { id: 'AIA-1787', symbol: 'AIA', name: 'DeAgentAI', network: 'Other' },
  { id: 'AIBT-1856', symbol: 'AIBT', name: 'AIByte', network: 'Other' },
  { id: 'AIDOGE-81', symbol: 'AIDOGE', name: 'ArbDoge AI', network: 'Other' },
  { id: 'AIDR-31', symbol: 'AIDR', name: 'AIDR', network: 'Other' },
  { id: 'AIH-1496', symbol: 'AIH', name: 'AIHub', network: 'Other' },
  { id: 'AINIG-1590', symbol: 'AINIG', name: 'Infinity Ground', network: 'Other' },
  { id: 'AIO-1677', symbol: 'AIO', name: 'OLAXBT', network: 'Other' },
  { id: 'AIOT-1676', symbol: 'AIOT', name: 'OKZOO', network: 'Other' },
  { id: 'AIOZ-34', symbol: 'AIOZ', name: 'AIOZ Network', network: 'Other' },
  { id: 'AIRA-1688', symbol: 'AIRA', name: 'AIRABYTE', network: 'Other' },
  { id: 'AITECH-1099', symbol: 'ACN', name: 'AITECH Cloud Network', network: 'Other' },
  { id: 'AIXBT-1377', symbol: 'AIXBT', name: 'aixbt', network: 'Other' },
  { id: 'AK12-38', symbol: 'AK12', name: 'AK12', network: 'Other' },
  { id: 'AKI-40', symbol: 'AKI', name: 'Aki Network', network: 'Other' },
  { id: 'AKT-39', symbol: 'AKT', name: 'Akash Network', network: 'Other' },
  { id: 'AL-84', symbol: 'AL', name: 'ArchLoot', network: 'Other' },
  { id: 'ALCH-1378', symbol: 'ALCH', name: 'Alchemist AI', network: 'Other' },
  { id: 'ALCX-41', symbol: 'ALCX', name: 'Alchemix', network: 'Other' },
  { id: 'ALE-32', symbol: 'ALE', name: 'Ailey', network: 'Other' },
  { id: 'ALGO-46', symbol: 'ALGO', name: 'Algorand', network: 'Other' },
  { id: 'ALICE-792', symbol: 'ALICE', name: 'MyNeighbourAlice', network: 'Other' },
  { id: 'ALIF-49', symbol: 'ALIF', name: 'ALIF COIN', network: 'Other' },
  { id: 'ALITAS-50', symbol: 'ALITAS', name: 'Alitas', network: 'Other' },
  { id: 'ALLO-1852', symbol: 'ALLO', name: 'ALLORA', network: 'Other' },
  { id: 'ALPACA-52', symbol: 'ALPACA', name: 'Alpaca Finance', network: 'Other' },
  { id: 'ALPH-44', symbol: 'ALPH', name: 'Alephium', network: 'Other' },
  { id: 'ALPHA-1129', symbol: 'ALPHA', name: 'Stella', network: 'Other' },
  { id: 'ALPINE-54', symbol: 'ALPINE', name: 'Alpine F1 Team Fan Token', network: 'Other' },
  { id: 'ALT-57', symbol: 'ALT', name: 'Altlayer', network: 'Other' },
  { id: 'ALU-58', symbol: 'ALU', name: 'Altura', network: 'Other' },
  { id: 'AMDON-1782', symbol: 'AMDON', name: 'AMD Tokenized Stock (Ondo)', network: 'Other' },
  { id: 'AMI-1556', symbol: 'AMI', name: 'Amnis Finance', network: 'Other' },
  { id: 'AMP-61', symbol: 'AMP', name: 'Amp', network: 'Other' },
  { id: 'AMZNON-1946', symbol: 'AMZNON', name: 'Amazon Tokenized Stock (Ondo)', network: 'Other' },
  { id: 'AMZNX-1690', symbol: 'AMZNX', name: 'Amazon tokenized stock', network: 'Other' },
  { id: 'ANA-64', symbol: 'ANA', name: 'Ana Coin', network: 'Other' },
  { id: 'ANDY-1365', symbol: 'ANDY', name: 'ANDY', network: 'Other' },
  { id: 'ANI-1557', symbol: 'ANI', name: 'Ani Grok Companion', network: 'Other' },
  { id: 'ANIME-1379', symbol: 'ANIME', name: 'Animecoin', network: 'Other' },
  { id: 'ANKR-70', symbol: 'ANKR', name: 'Ankr', network: 'Other' },
  { id: 'ANLOG-1380', symbol: 'ANLOG', name: 'Analog', network: 'Other' },
  { id: 'ANOA-71', symbol: 'ANOA', name: 'Anoa', network: 'Other' },
  { id: 'ANOME-1691', symbol: 'ANOME', name: 'Anome', network: 'Other' },
  { id: 'AO-1558', symbol: 'AO', name: 'AO Computer', network: 'Other' },
  { id: 'APE-73', symbol: 'APE', name: 'ApeCoin', network: 'Other' },
  { id: 'APEX-76', symbol: 'APEX', name: 'ApeX Protocol', network: 'Other' },
  { id: 'API3-77', symbol: 'API3', name: 'API3', network: 'Other' },
  { id: 'APP-1033', symbol: 'APP', name: 'RWAX', network: 'Other' },
  { id: 'APR-1844', symbol: 'APR', name: 'aPriori', network: 'Other' },
  { id: 'APT-78', symbol: 'APT', name: 'Aptos', network: 'Other' },
  { id: 'APU-79', symbol: 'APU', name: 'Apu Apustaja', network: 'Other' },
  { id: 'AQT-53', symbol: 'AQT', name: 'Alpha Quark Token', network: 'Other' },
  { id: 'AR-102', symbol: 'AR', name: 'Arweave', network: 'Other' },
  { id: 'ARB-82', symbol: 'ARB', name: 'Arbitrum', network: 'Other' },
  { id: 'ARC-1382', symbol: 'ARC', name: 'AI Rig Complex', network: 'Other' },
  { id: 'ARDR-86', symbol: 'ARDR', name: 'Ardor', network: 'Other' },
  { id: 'ARG-88', symbol: 'ARG', name: 'Argentine Football Association Fan Token', network: 'Other' },
  { id: 'ARIA-1816', symbol: 'ARIA', name: 'AriaAI', network: 'Other' },
  { id: 'ARK-91', symbol: 'ARK', name: 'ARK', network: 'Other' },
  { id: 'ARKM-92', symbol: 'ARKM', name: 'Arkham', network: 'Other' },
  { id: 'ARPA-94', symbol: 'ARPA', name: 'ARPA', network: 'Other' },
  { id: 'ART-1815', symbol: 'ART', name: 'Liveart', network: 'Other' },
  { id: 'ARTY-101', symbol: 'ARTY', name: 'Artyfact', network: 'Other' },
  { id: 'ASDD-1546', symbol: 'ASDD', name: 'ASDigital Dollar', network: 'Other' },
  { id: 'ASETQU-1755', symbol: 'ASETQU', name: 'AsetQu', network: 'Other' },
  { id: 'ASP-1692', symbol: 'ASP', name: 'Aspecta', network: 'Other' },
  { id: 'ASR-103', symbol: 'ASR', name: 'AS Roma Fan Token', network: 'Other' },
  { id: 'ASRR-1660', symbol: 'ASRR', name: 'Assisterr AI', network: 'Other' },
  { id: 'AST-36', symbol: 'AST', name: 'AirSwap', network: 'Other' },
  { id: 'ASTER-1753', symbol: 'ASTER', name: 'Aster', network: 'Other' },
  { id: 'ASTR-106', symbol: 'ASTR', name: 'Astar', network: 'Other' },
  { id: 'AT-1869', symbol: 'AT', name: 'APRO', network: 'Other' },
  { id: 'ATA-117', symbol: 'ATA', name: 'Automata Network', network: 'Other' },
  { id: 'ATH-27', symbol: 'ATH', name: 'Aethir', network: 'Other' },
  { id: 'ATLAS-1119', symbol: 'ATLAS', name: 'Star Atlas', network: 'Other' },
  { id: 'ATM-108', symbol: 'ATM', name: 'Atletico De Madrid Fan Token', network: 'Other' },
  { id: 'ATOM-287', symbol: 'ATOM', name: 'Cosmos', network: 'Other' },
  { id: 'ATR-100', symbol: 'ATR', name: 'Artrade token', network: 'Other' },
  { id: 'ATT-109', symbol: 'ATT', name: 'Attila', network: 'Other' },
  { id: 'ATT2-1439', symbol: 'ATT2', name: 'Advertising Time Trace', network: 'Other' },
  { id: 'AUCTION-202', symbol: 'AUCTION', name: 'Bounce Token', network: 'Other' },
  { id: 'AUDIO-110', symbol: 'AUDIO', name: 'Audius', network: 'Other' },
  { id: 'AURA-1502', symbol: 'AURA', name: 'Aura', network: 'Other' },
  { id: 'AURORA-1384', symbol: 'AURORA', name: 'Aurora', network: 'Other' },
  { id: 'AUSD-1385', symbol: 'AUSD', name: 'AUSD', network: 'Other' },
  { id: 'AVA-119', symbol: 'AVA', name: 'AVA', network: 'Other' },
  { id: 'AVAAI-1449', symbol: 'AVAAI', name: 'AVA', network: 'Other' },
  { id: 'AVAIL-121', symbol: 'AVAIL', name: 'Avail', network: 'Other' },
  { id: 'AVAX-122', symbol: 'AVAX', name: 'Avalanche', network: 'Other' },
  { id: 'AVGOON-1759', symbol: 'AVGOON', name: 'Broadcom Tokenized Stock (Ondo)', network: 'Other' },
  { id: 'AVL-1450', symbol: 'AVL', name: 'Avalon Labs', network: 'Other' },
  { id: 'AVNT-1764', symbol: 'AVNT', name: 'Avantis', network: 'Other' },
  { id: 'AWE-1189', symbol: 'AWE', name: 'The Autonomous Worlds Engine', network: 'Other' },
  { id: 'AXL-125', symbol: 'AXL', name: 'Axelar', network: 'Other' },
  { id: 'AXS-126', symbol: 'AXS', name: 'Axie Infinity', network: 'Other' },
  { id: 'AZIT-127', symbol: 'AZIT', name: 'Azit', network: 'Other' },
  { id: 'AZTEC-1954', symbol: 'AZTEC', name: 'Aztec', network: 'Other' },
  { id: 'B-1504', symbol: 'B', name: 'BUILDon', network: 'Other' },
  { id: 'B2-1454', symbol: 'B2', name: 'BSquared Network', network: 'Other' },
  { id: 'B3TR-1641', symbol: 'B3TR', name: 'VeBetterDAO', network: 'Other' },
  { id: 'BABAON-1761', symbol: 'BABAON', name: 'Alibaba Tokenized Stock (Ondo)', network: 'Other' },
  { id: 'BABY-1386', symbol: 'BABY', name: 'Babylon', network: 'Other' },
  { id: 'BABYDOGE-129', symbol: 'BABYDOGE', name: 'Baby Doge Coin', network: 'Other' },
  { id: 'BADGER-132', symbol: 'BADGER', name: 'Badger DAO', network: 'Other' },
  { id: 'BAKE-133', symbol: 'BAKE', name: 'BakeryToken', network: 'BNB SmartChain' },
  { id: 'BAL-134', symbol: 'BAL', name: 'Balancer', network: 'Other' },
  { id: 'BAN-1387', symbol: 'BAN', name: 'Comedian', network: 'Other' },
  { id: 'BANANA-135', symbol: 'BANANA', name: 'Banana Gun', network: 'Other' },
  { id: 'BANANAS31-1503', symbol: 'BANANAS31', name: 'Banana For Scale', network: 'Other' },
  { id: 'BAND-137', symbol: 'BAND', name: 'Band', network: 'Other' },
  { id: 'BANK-1471', symbol: 'BANK', name: 'Lorenzo Protocol', network: 'Other' },
  { id: 'BAR-436', symbol: 'BAR', name: 'FC Barcelona Fan Token', network: 'Other' },
  { id: 'BARD-1771', symbol: 'BARD', name: 'Lombard', network: 'Other' },
  { id: 'BAT-139', symbol: 'BAT', name: 'Basic Attention Token', network: 'Other' },
  { id: 'BB-203', symbol: 'BB', name: 'BounceBit', network: 'Other' },
  { id: 'BCH-161', symbol: 'BCH', name: 'Bitcoin Cash', network: 'Bitcoin' },
  { id: 'BCUT-172', symbol: 'BCUT', name: 'bitsCrunch', network: 'Other' },
  { id: 'BDXN-1545', symbol: 'BDXN', name: 'Bondex', network: 'Other' },
  { id: 'BEAM-140', symbol: 'BEAM', name: 'Beam', network: 'Other' },
  { id: 'BEAT-1880', symbol: 'BEAT', name: 'Audiera', network: 'Other' },
  { id: 'BEFI-144', symbol: 'BEFI', name: 'BeFi Labs', network: 'Other' },
  { id: 'BEL-145', symbol: 'BEL', name: 'Bella Protocol', network: 'Other' },
  { id: 'BELIEVE-1805', symbol: 'BELIEVE', name: 'BELIEVE', network: 'Other' },
  { id: 'BERA-1389', symbol: 'BERA', name: 'Berachain', network: 'Other' },
  { id: 'BETA-149', symbol: 'BETA', name: 'Beta Finance', network: 'Other' },
  { id: 'BFC-153', symbol: 'BFC', name: 'Bifrost', network: 'Other' },
  { id: 'BFUSD-1799', symbol: 'BFUSD', name: 'BFUSD', network: 'Other' },
  { id: 'BGB-169', symbol: 'BGB', name: 'Bitget Token', network: 'Other' },
  { id: 'BGSC-1390', symbol: 'BGSC', name: 'BugsCoin', network: 'Other' },
  { id: 'BHC-1892', symbol: 'BHC', name: 'Block Hub Coin', network: 'Other' },
  { id: 'BIANRENSHENG-1887', symbol: '币安人生', name: '币安人生 (BinanceLife)', network: 'BNB SmartChain' },
  { id: 'BICO-151', symbol: 'BICO', name: 'Biconomy', network: 'Other' },
  { id: 'BIFI-142', symbol: 'BIFI', name: 'Beefy', network: 'Other' },
  { id: 'BIGTIME-154', symbol: 'BIGTIME', name: 'BigTime', network: 'Other' },
  { id: 'BILLY-155', symbol: 'BILLY', name: 'Billy', network: 'Other' },
  { id: 'BIO-1391', symbol: 'BIO', name: 'Bio Protocol', network: 'Other' },
  { id: 'BIRB-1920', symbol: 'BIRB', name: 'Moonbirds', network: 'Other' },
  { id: 'BITCOIN-532', symbol: 'BITCOIN', name: 'HarryPotterObamaSonic10Inu (ERC-20)', network: 'Other' },
  { id: 'BLAST-179', symbol: 'BLAST', name: 'Blast', network: 'Other' },
  { id: 'BLESS-1789', symbol: 'BLESS', name: 'Bless', network: 'Other' },
  { id: 'BLKON-1926', symbol: 'BLKON', name: 'BlackRock Tokenized Stock (Ondo)', network: 'Other' },
  { id: 'BLUE-1392', symbol: 'BLUE', name: 'Bluefin', network: 'Other' },
  { id: 'BLUM-1453', symbol: 'BLUM', name: 'Blum', network: 'Other' },
  { id: 'BLUR-187', symbol: 'BLUR', name: 'Blur', network: 'Other' },
  { id: 'BLZ-188', symbol: 'BLZ', name: 'Bluzelle', network: 'Other' },
  { id: 'BMT-1393', symbol: 'BMT', name: 'Bubblemaps', network: 'Other' },
  { id: 'BNB-189', symbol: 'BNB', name: 'BNB', network: 'BNB SmartChain' },
  { id: 'BNKR-1833', symbol: 'BNKR', name: 'Bankr Coin', network: 'Other' },
  { id: 'BNSOL-156', symbol: 'BNSOL', name: 'Binance Staked SOL', network: 'BNB SmartChain' },
  { id: 'BNT-136', symbol: 'BNT', name: 'Bancor', network: 'Other' },
  { id: 'BOB-1879', symbol: 'BOB', name: 'BOB (Build on Bitcoin)', network: 'Bitcoin' },
  { id: 'BOBA-193', symbol: 'BOBA', name: 'Boba Network', network: 'Other' },
  { id: 'BOBO-194', symbol: 'BOBO', name: 'BOBO', network: 'Other' },
  { id: 'BOMB-1561', symbol: 'BOMB', name: 'Bombie', network: 'Other' },
  { id: 'BOME-198', symbol: 'BOME', name: 'BOOK OF MEME', network: 'Other' },
  { id: 'BOND-138', symbol: 'BOND', name: 'BarnBridge', network: 'Other' },
  { id: 'BONE-195', symbol: 'BONE', name: 'BONE SHIBASWAP', network: 'Other' },
  { id: 'BONK-196', symbol: 'BONK', name: 'Bonk', network: 'Other' },
  { id: 'BOOST-1814', symbol: 'BOOST', name: 'Boost', network: 'Other' },
  { id: 'BORA-199', symbol: 'BORA', name: 'BORA', network: 'Other' },
  { id: 'BP-1984', symbol: 'BP', name: 'Backpack', network: 'Other' },
  { id: 'BR-1452', symbol: 'BR', name: 'Bedrock', network: 'Other' },
  { id: 'BRETT-206', symbol: 'BRETT', name: 'Brett (Based)', network: 'Other' },
  { id: 'BREV-1899', symbol: 'BREV', name: 'Brevis', network: 'Other' },
  { id: 'BRIC-1622', symbol: 'BRIC', name: 'Redbrick', network: 'Other' },
  { id: 'BRISE-168', symbol: 'BRISE', name: 'Bitgert', network: 'Other' },
  { id: 'BROCCOLI-1395', symbol: 'BROCCOLI', name: 'CZ DOG', network: 'Other' },
  { id: 'BSU-1845', symbol: 'BSU', name: 'Baby Shark Universe', network: 'Other' },
  { id: 'BSV-166', symbol: 'BSV', name: 'Bitcoin SV', network: 'Bitcoin' },
  { id: 'BSW-159', symbol: 'BSW', name: 'Biswap', network: 'Other' },
  { id: 'BTC-160', symbol: 'BTC', name: 'Bitcoin', network: 'Bitcoin' },
  { id: 'BTG-1796', symbol: 'BTG', name: 'Openverse Network', network: 'Other' },
  { id: 'BTGOON-1978', symbol: 'BTGOON', name: 'BitGo Holdings Tokenized Stock (ONDO)', network: 'Other' },
  { id: 'BTL-1891', symbol: 'BTL', name: 'Bitelions', network: 'Other' },
  { id: 'BTR-210', symbol: 'BTR', name: 'BTRIPS', network: 'Other' },
  { id: 'BTT-176', symbol: 'BTT', name: 'BitTorrent(New)', network: 'Other' },
  { id: 'BULLA-1544', symbol: 'BULLA', name: 'Bulla', network: 'Other' },
  { id: 'BUZZ-1397', symbol: 'BUZZ', name: 'Hive AI', network: 'Other' },
  { id: 'C-1565', symbol: 'C', name: 'Chainbase', network: 'Other' },
  { id: 'C98-267', symbol: 'C98', name: 'Coin98', network: 'Other' },
  { id: 'CAKE-896', symbol: 'CAKE', name: 'PancakeSwap', network: 'BNB SmartChain' },
  { id: 'CAMP-1695', symbol: 'CAMP', name: 'Camp Network', network: 'Other' },
  { id: 'CARV-225', symbol: 'CARV', name: 'CARV', network: 'Other' },
  { id: 'CAST-1853', symbol: 'CAST', name: 'CAST', network: 'Other' },
  { id: 'CAT-1073', symbol: 'CAT', name: "Simon's Cat", network: 'Other' },
  { id: 'CATI-234', symbol: 'CATI', name: 'Catizen', network: 'Other' },
  { id: 'CBG-244', symbol: 'CBG', name: 'Chainbing', network: 'Other' },
  { id: 'CBK-266', symbol: 'CBK', name: 'Cobak Token', network: 'Other' },
  { id: 'CC-1826', symbol: 'CC', name: 'CantonNetwork', network: 'Other' },
  { id: 'CEL-241', symbol: 'CEL', name: 'Celsius', network: 'Other' },
  { id: 'CELO-239', symbol: 'CELO', name: 'Celo', network: 'Other' },
  { id: 'CELR-237', symbol: 'CELR', name: 'Celer Network', network: 'Other' },
  { id: 'CESS-1564', symbol: 'CESS', name: 'CESS Network', network: 'Other' },
  { id: 'CETUS-243', symbol: 'CETUS', name: 'Cetus Protocol', network: 'Other' },
  { id: 'CFG-242', symbol: 'CFG', name: 'Centrifuge', network: 'Other' },
  { id: 'CFX-274', symbol: 'CFX', name: 'Conflux', network: 'Other' },
  { id: 'CGN-1825', symbol: 'CGN', name: 'Cygnus', network: 'Other' },
  { id: 'CGPT-247', symbol: 'CGPT', name: 'ChainGPT', network: 'Other' },
  { id: 'CHEEMS-1398', symbol: 'CHEEMS', name: 'Cheems (cheems.pet)', network: 'Other' },
  { id: 'CHESS-1217', symbol: 'CHESS', name: 'Tranchess', network: 'Other' },
  { id: 'CHILLGUY-603', symbol: 'CHILLGUY', name: 'Just a chill guy', network: 'Other' },
  { id: 'CHR-255', symbol: 'CHR', name: 'Chromia', network: 'Other' },
  { id: 'CHT-309', symbol: 'CHT', name: 'CyberHarbor', network: 'Other' },
  { id: 'CHZ-253', symbol: 'CHZ', name: 'Chiliz', network: 'Other' },
  { id: 'CITY-695', symbol: 'CITY', name: 'Manchester City Fan Token', network: 'Other' },
  { id: 'CJL-1497', symbol: 'CJL', name: 'CJournal', network: 'Other' },
  { id: 'CKB-811', symbol: 'CKB', name: 'Nervos Network', network: 'Other' },
  { id: 'CLAWNCH-1941', symbol: 'CLAWNCH', name: 'Clawnch', network: 'Other' },
  { id: 'CLO-1898', symbol: 'CLO', name: 'Yei Finance (Clovis)', network: 'Other' },
  { id: 'CLOUD-263', symbol: 'CLOUD', name: 'Cloud', network: 'Other' },
  { id: 'CLV-264', symbol: 'CLV', name: 'CLV', network: 'Other' },
  { id: 'CMCSAX-1959', symbol: 'CMCSAX', name: 'Comcast Tokenized Stock (xStock)', network: 'Other' },
  { id: 'CNG-269', symbol: 'CNG', name: 'CoinNavigator', network: 'Other' },
  { id: 'COA-1659', symbol: 'COA', name: 'Alliance Games', network: 'Other' },
  { id: 'COAI-1804', symbol: 'COAI', name: 'ChainOpera AI', network: 'Other' },
  { id: 'COINON-1966', symbol: 'COINON', name: 'Coinbase Tokenized Stock (Ondo)', network: 'Other' },
  { id: 'COINX-1533', symbol: 'COINX', name: 'Coinbase tokenized stock', network: 'Other' },
  { id: 'COL-259', symbol: 'COL', name: 'Clash of Liliput', network: 'Other' },
  { id: 'COLLAT-1663', symbol: 'COLLAT', name: 'Collaterize', network: 'Other' },
  { id: 'COLLECT-1883', symbol: 'COLLECT', name: 'Collect on Fanable', network: 'Other' },
  { id: 'COMP-273', symbol: 'COMP', name: 'Compound', network: 'Other' },
  { id: 'CONX-275', symbol: 'CONX', name: 'Connex', network: 'Other' },
  { id: 'COOKIE-280', symbol: 'COOKIE', name: 'Cookie DAO', network: 'Other' },
  { id: 'COPXON-1911', symbol: 'COPXON', name: 'Global X Copper Miners Tokenized ETF (Ondo)', network: 'Other' },
  { id: 'COQ-281', symbol: 'COQ', name: 'Coq Inu', network: 'Other' },
  { id: 'CORE-282', symbol: 'CORE', name: 'Core', network: 'Other' },
  { id: 'CORN-1456', symbol: 'CORN', name: 'CORN', network: 'Other' },
  { id: 'COS-277', symbol: 'COS', name: 'Contentos', network: 'Other' },
  { id: 'COTI-289', symbol: 'COTI', name: 'COTI', network: 'Other' },
  { id: 'COW-292', symbol: 'COW', name: 'CoW Protocol', network: 'Other' },
  { id: 'CPOOL-260', symbol: 'CPOOL', name: 'Clearpool', network: 'Other' },
  { id: 'CRCLON-1964', symbol: 'CRCLON', name: 'Circle Internet Group Tokenized Stock (Ondo)', network: 'Other' },
  { id: 'CRCLX-1532', symbol: 'CRCLX', name: 'Circle tokenized stock', network: 'Other' },
  { id: 'CREAM-293', symbol: 'CREAM', name: 'Cream Finance', network: 'Other' },
  { id: 'CREO-295', symbol: 'CREO', name: 'Creo Engine', network: 'Other' },
  { id: 'CRMON-1942', symbol: 'CRMON', name: 'Salesforce Tokenized Stock (Ondo)', network: 'Other' },
  { id: 'CRO-297', symbol: 'CRO', name: 'Cronos', network: 'Other' },
  { id: 'CROAK-1697', symbol: 'CROAK', name: 'Croak', network: 'Other' },
  { id: 'CROSS-1569', symbol: 'CROSS', name: 'CROSS', network: 'Other' },
  { id: 'CRV-307', symbol: 'CRV', name: 'Curve DAO Token', network: 'Other' },
  { id: 'CSCOON-1938', symbol: 'CSCOON', name: 'Cisco Systems Tokenized Stock (Ondo)', network: 'Other' },
  { id: 'CSPR-227', symbol: 'CSPR', name: 'Casper', network: 'Other' },
  { id: 'CST-304', symbol: 'CST', name: 'Crypto Sustainable Token', network: 'Other' },
  { id: 'CSTAR-1567', symbol: 'CSTAR', name: 'CoinStar', network: 'Other' },
  { id: 'CTA-1570', symbol: 'CTA', name: 'Cross The Ages', network: 'Other' },
  { id: 'CTC-294', symbol: 'CTC', name: 'Creditcoin', network: 'Other' },
  { id: 'CTK-1061', symbol: 'CTK', name: 'Shentu', network: 'Other' },
  { id: 'CTSI-224', symbol: 'CTSI', name: 'Cartesi', network: 'Other' },
  { id: 'CUDIS-1505', symbol: 'CUDIS', name: 'Cudis', network: 'Other' },
  { id: 'CVC-258', symbol: 'CVC', name: 'Civic', network: 'Other' },
  { id: 'CVX-278', symbol: 'CVX', name: 'Convex Finance', network: 'Other' },
  { id: 'CVXON-1897', symbol: 'CVXON', name: 'Chevron Tokenized Stock (Ondo)', network: 'Other' },
  { id: 'CWEB-270', symbol: 'CWEB', name: 'Coinweb', network: 'Other' },
  { id: 'CXT-291', symbol: 'CXT', name: 'Covalent X Token', network: 'Other' },
  { id: 'CYBER-308', symbol: 'CYBER', name: 'CyberConnect', network: 'Other' },
  { id: 'CYC-1698', symbol: 'CYC', name: 'Cycle Network', network: 'Other' },
  { id: 'CYPR-1797', symbol: 'CYPR', name: 'Cypher', network: 'Other' },
  { id: 'D-1357', symbol: 'D', name: 'DAR Open Network', network: 'Other' },
  { id: 'DAI-313', symbol: 'DAI', name: 'Dai', network: 'Ethereum' },
  { id: 'DAO-314', symbol: 'DAO', name: 'DAO Maker', network: 'Other' },
  { id: 'DARK-1457', symbol: 'DARK', name: 'Dark Eclipse', network: 'Other' },
  { id: 'DASH-1400', symbol: 'DASH', name: 'DASH', network: 'Other' },
  { id: 'DATA-1137', symbol: 'DATA', name: 'Streamr', network: 'Other' },
  { id: 'DBR-1571', symbol: 'DBR', name: 'deBridge', network: 'Other' },
  { id: 'DCOIN-1401', symbol: 'DCOIN', name: 'DaVinci Protocol', network: 'Other' },
  { id: 'DCR-328', symbol: 'DCR', name: 'Decred', network: 'Other' },
  { id: 'DCT-339', symbol: 'DCT', name: 'Degree Crypto Token', network: 'Other' },
  { id: 'DEAI-1350', symbol: 'DEAI', name: 'Zero 1 Labs', network: 'Other' },
  { id: 'DEEP-331', symbol: 'DEEP', name: 'DeepBook Protocol', network: 'Other' },
  { id: 'DEFI-332', symbol: 'DEFI', name: 'DeFi', network: 'Other' },
  { id: 'DEGEN-336', symbol: 'DEGEN', name: 'Degen', network: 'Other' },
  { id: 'DEGO-338', symbol: 'DEGO', name: 'Dego Finance', network: 'Other' },
  { id: 'DENT-341', symbol: 'DENT', name: 'Dent', network: 'Other' },
  { id: 'DEP-322', symbol: 'DEP', name: 'DEAPCOIN', network: 'Other' },
  { id: 'DEXE-346', symbol: 'DEXE', name: 'DeXe', network: 'Other' },
  { id: 'DF-348', symbol: 'DF', name: 'dForce', network: 'Other' },
  { id: 'DFDVX-1700', symbol: 'DFDVX', name: 'DFDV tokenized stock', network: 'Other' },
  { id: 'DFG-334', symbol: 'DFG', name: 'Defigram', network: 'Other' },
  { id: 'DGB-353', symbol: 'DGB', name: 'DigiByte', network: 'Other' },
  { id: 'DHRX-1975', symbol: 'DHRX', name: 'Danaher tokenized stock (xStock)', network: 'Other' },
  { id: 'DIA-350', symbol: 'DIA', name: 'DIA', network: 'Other' },
  { id: 'DIDID-352', symbol: 'DIDID', name: 'Didi Duck', network: 'Other' },
  { id: 'DKA-358', symbol: 'DKA', name: 'dKargo', network: 'Other' },
  { id: 'DLC-351', symbol: 'DLC', name: 'Diverge Loop', network: 'Other' },
  { id: 'DMAIL-359', symbol: 'DMAIL', name: 'DMAIL Network', network: 'Other' },
  { id: 'DMC-1572', symbol: 'DMC', name: 'DeLorean', network: 'Other' },
  { id: 'DN-1896', symbol: 'DN', name: 'DeepNode', network: 'Other' },
  { id: 'DNT-357', symbol: 'DNT', name: 'district0x', network: 'Other' },
  { id: 'DODO-361', symbol: 'DODO', name: 'DODO', network: 'Other' },
  { id: 'DOG-362', symbol: 'DOG', name: 'Dog (Bitcoin)', network: 'Bitcoin' },
  { id: 'DOGE-364', symbol: 'DOGE', name: 'Dogecoin', network: 'Other' },
  { id: 'DOGE2-1440', symbol: 'DOGE2', name: 'Department Of Government Efficiency', network: 'Other' },
  { id: 'DOGS-367', symbol: 'DOGS', name: 'DOGS', network: 'Other' },
  { id: 'DOLO-1458', symbol: 'DOLO', name: 'Dolomite', network: 'Other' },
  { id: 'DOME-426', symbol: 'DOME', name: 'HumainWeb3', network: 'Other' },
  { id: 'DOOD-1528', symbol: 'DOOD', name: 'Doodles', network: 'Other' },
  { id: 'DOT-943', symbol: 'DOT', name: 'Polkadot', network: 'Other' },
  { id: 'DRIFT-376', symbol: 'DRIFT', name: 'Drift', network: 'Other' },
  { id: 'DRX-377', symbol: 'DRX', name: 'DRX Token', network: 'Other' },
  { id: 'DSYNC-1699', symbol: 'DSYNC', name: 'Destra Network', network: 'Other' },
  { id: 'DTEC-378', symbol: 'DTEC', name: 'Dtec', network: 'Other' },
  { id: 'DUCK-1574', symbol: 'DUCK', name: 'DuckChain', network: 'Other' },
  { id: 'DUEL-475', symbol: 'DUEL', name: 'GameGPT', network: 'Other' },
  { id: 'DUKO-380', symbol: 'DUKO', name: 'DUKO', network: 'Other' },
  { id: 'DUPE-1658', symbol: 'DUPE', name: 'Dupe', network: 'Other' },
  { id: 'DUSK-381', symbol: 'DUSK', name: 'Dusk', network: 'Other' },
  { id: 'DVI-382', symbol: 'DVI', name: 'Dvision Network', network: 'Other' },
  { id: 'DYDX-383', symbol: 'DYDX', name: 'dYdX', network: 'Other' },
  { id: 'DYM-384', symbol: 'DYM', name: 'Dymension', network: 'Other' },
  { id: 'ECHO-1665', symbol: 'ECHO', name: 'Echo Protocol', network: 'Other' },
  { id: 'EDEL-1982', symbol: 'EDEL', name: 'Edel', network: 'Other' },
  { id: 'EDEN-1772', symbol: 'EDEN', name: 'OpenEden', network: 'Other' },
  { id: 'EDENA-1701', symbol: 'EDENA', name: 'Edena', network: 'Other' },
  { id: 'EDGEN-1508', symbol: 'EDGEN', name: 'Layeredge', network: 'Other' },
  { id: 'EDU-868', symbol: 'EDU', name: 'Open Campus', network: 'Other' },
  { id: 'EEMON-1939', symbol: 'EEMON', name: 'iShares MSCI Emerging Markets Tokenized ETF (Ondo)', network: 'Other' },
  { id: 'EFI-394', symbol: 'EFI', name: 'Efinity Token', network: 'Other' },
  { id: 'EGL1-1577', symbol: 'EGL1', name: 'egl1', network: 'Other' },
  { id: 'EGLD-787', symbol: 'EGLD', name: 'MultiversX', network: 'Other' },
  { id: 'EIGEN-397', symbol: 'EIGEN', name: 'EigenCloud', network: 'Other' },
  { id: 'ELA-400', symbol: 'ELA', name: 'Elastos', network: 'Other' },
  { id: 'ELDE-1578', symbol: 'ELDE', name: 'Elderglade', network: 'Other' },
  { id: 'ELF-23', symbol: 'ELF', name: 'aelf', network: 'Other' },
  { id: 'ELIZAOS-1811', symbol: 'ELIZAOS', name: 'ELIZAOS', network: 'Other' },
  { id: 'ELON-365', symbol: 'ELON', name: 'Dogelon Mars', network: 'Other' },
  { id: 'ELP-1703', symbol: 'ELP', name: 'Elympics', network: 'Other' },
  { id: 'ELSA-1904', symbol: 'ELSA', name: 'HeyElsa', network: 'Other' },
  { id: 'ELX-1579', symbol: 'ELX', name: 'Elixir', network: 'Other' },
  { id: 'ENA-416', symbol: 'ENA', name: 'Ethena', network: 'Other' },
  { id: 'ENJ-409', symbol: 'ENJ', name: 'Enjin Coin', network: 'Other' },
  { id: 'ENS-421', symbol: 'ENS', name: 'Ethereum Name Service', network: 'Ethereum' },
  { id: 'ENSO-1802', symbol: 'ENSO', name: 'Enso', network: 'Other' },
  { id: 'EOS-412', symbol: 'EOS', name: 'EOS', network: 'Other' },
  { id: 'EPIC-1358', symbol: 'EPIC', name: 'Epic Chain', network: 'Other' },
  { id: 'EPT-1451', symbol: 'EPT', name: 'Balance', network: 'Other' },
  { id: 'ERA-1562', symbol: 'ERA', name: 'Caldera', network: 'Other' },
  { id: 'ES-1576', symbol: 'ES', name: 'Eclipse', network: 'Other' },
  { id: 'ESE-392', symbol: 'ESE', name: 'Eesee', network: 'Other' },
  { id: 'ESP-1974', symbol: 'ESP', name: 'Espresso', network: 'Other' },
  { id: 'ESPORTS-1649', symbol: 'ESPORTS', name: 'Yooldo', network: 'Other' },
  { id: 'ETC-420', symbol: 'ETC', name: 'Ethereum Classic', network: 'Ethereum' },
  { id: 'ETH-419', symbol: 'ETH', name: 'Ethereum', network: 'Ethereum' },
  { id: 'ETHFI-418', symbol: 'ETHFI', name: 'ether.fi', network: 'Other' },
  { id: 'ETHW-422', symbol: 'ETHW', name: 'EthereumPoW', network: 'Ethereum' },
  { id: 'ETN-402', symbol: 'ETN', name: 'Electroneum', network: 'Tron' },
  { id: 'EUL-1803', symbol: 'EUL', name: 'Euler', network: 'Other' },
  { id: 'EURI-425', symbol: 'EURI', name: 'Eurite', network: 'Other' },
  { id: 'EURS-1124', symbol: 'EURS', name: 'Stasis Euro', network: 'Other' },
  { id: 'EVER-427', symbol: 'EVER', name: 'Everscale', network: 'Other' },
  { id: 'EWJON-1994', symbol: 'EWJON', name: 'iShares MSCI Japan Tokenized ETF (Ondo)', network: 'Other' },
  { id: 'EWYON-1996', symbol: 'EWYON', name: 'iShares MSCI South Korea Tokenized ETF (Ondo)', network: 'Other' },
  { id: 'EZFIN-1402', symbol: 'EZFIN', name: 'EzFin', network: 'Other' },
  { id: 'F-1631', symbol: 'F', name: 'SynFutures', network: 'Other' },
  { id: 'FANC-431', symbol: 'FANC', name: 'fanC', network: 'Other' },
  { id: 'FARM-533', symbol: 'FARM', name: 'Harvest Finance', network: 'Other' },
  { id: 'FARTCOIN-434', symbol: 'FARTCOIN', name: 'Fartcoin', network: 'Other' },
  { id: 'FDUSD-442', symbol: 'FDUSD', name: 'First Digital USD', network: 'Other' },
  { id: 'FET-99', symbol: 'FET', name: 'Artificial Superintelligence Alliance', network: 'Other' },
  { id: 'FF-1774', symbol: 'FF', name: 'Falcon Finance', network: 'Other' },
  { id: 'FHE-1476', symbol: 'FHE', name: 'Mind Network', network: 'Other' },
  { id: 'FIDA-1094', symbol: 'FIDA', name: 'Solana Name Service', network: 'Solana' },
  { id: 'FIGHT-1919', symbol: 'FIGHT', name: 'Fight', network: 'Other' },
  { id: 'FIL-438', symbol: 'FIL', name: 'Filecoin', network: 'Other' },
  { id: 'FIO-439', symbol: 'FIO', name: 'FIO Protocol', network: 'Other' },
  { id: 'FIS-1116', symbol: 'FIS', name: 'Stafi', network: 'Other' },
  { id: 'FITFI-1131', symbol: 'FITFI', name: 'Step App', network: 'Other' },
  { id: 'FLIP-245', symbol: 'FLIP', name: 'Chainflip', network: 'Other' },
  { id: 'FLK-1821', symbol: 'FLK', name: 'Fleek', network: 'Other' },
  { id: 'FLM-443', symbol: 'FLM', name: 'Flamingo', network: 'Other' },
  { id: 'FLOCK-1583', symbol: 'FLOCK', name: 'FLOCK', network: 'Other' },
  { id: 'FLOKI-446', symbol: 'FLOKI', name: 'FLOKI', network: 'Other' },
  { id: 'FLOW-447', symbol: 'FLOW', name: 'Flow', network: 'Other' },
  { id: 'FLR-445', symbol: 'FLR', name: 'Flare', network: 'Other' },
  { id: 'FLUID-1459', symbol: 'FLUID', name: 'Fluid', network: 'Other' },
  { id: 'FLUX-449', symbol: 'FLUX', name: 'Flux', network: 'Other' },
  { id: 'FOGO-1888', symbol: 'FOGO', name: 'Fogo', network: 'Other' },
  { id: 'FOLKS-1859', symbol: 'FOLKS', name: 'Folks Finance', network: 'Other' },
  { id: 'FORM-452', symbol: 'FORM', name: 'Four', network: 'Other' },
  { id: 'FORT-450', symbol: 'FORT', name: 'Forta', network: 'Other' },
  { id: 'FORTH-63', symbol: 'FORTH', name: 'Ampleforth Governance Token', network: 'Other' },
  { id: 'FOXY-453', symbol: 'FOXY', name: 'Foxy', network: 'Other' },
  { id: 'FRAG-1584', symbol: 'FRAG', name: 'Fragmetric', network: 'Other' },
  { id: 'FUEL-1404', symbol: 'FUEL', name: 'Fuel', network: 'Other' },
  { id: 'FUN-460', symbol: 'FUN', name: 'FUNToken', network: 'Other' },
  { id: 'FWOG-462', symbol: 'FWOG', name: 'Fwog (SOL)', network: 'Other' },
  { id: 'FXS-454', symbol: 'FRAX', name: 'Frax', network: 'Other' },
  { id: 'G-516', symbol: 'G', name: 'Gravity', network: 'Other' },
  { id: 'G7-1586', symbol: 'G7', name: 'Game7', network: 'Other' },
  { id: 'GAFI-474', symbol: 'GAFI', name: 'GameFi.org', network: 'Other' },
  { id: 'GAIA-1667', symbol: 'GAIA', name: 'Gaia', network: 'Other' },
  { id: 'GALA-465', symbol: 'GALA', name: 'Gala', network: 'Other' },
  { id: 'GALFT-467', symbol: 'GALFT', name: 'Galatasaray Fan Token', network: 'Other' },
  { id: 'GAME-472', symbol: 'GAME', name: 'GameBuild', network: 'Other' },
  { id: 'GAMEVRTL-1585', symbol: 'GAMEVRTL', name: 'GAME by Virtuals', network: 'Other' },
  { id: 'GAS-479', symbol: 'GAS', name: 'Gas', network: 'Other' },
  { id: 'GATA-1827', symbol: 'GATA', name: 'GATA', network: 'Other' },
  { id: 'GEAR-480', symbol: 'GEAR', name: 'Gearbox Protocol', network: 'Other' },
  { id: 'GFAL-477', symbol: 'GFAL', name: 'Games for a Living', network: 'Other' },
  { id: 'GFI-505', symbol: 'GFI', name: 'Goldfinch', network: 'Other' },
  { id: 'GHST-10', symbol: 'GHST', name: 'Aavegotchi', network: 'Other' },
  { id: 'GICT-487', symbol: 'GICT', name: 'GICTrade', network: 'Other' },
  { id: 'GIDR-488', symbol: 'GIDR', name: 'GIDR', network: 'Other' },
  { id: 'GIGA-490', symbol: 'GIGA', name: 'Gigachad (gigachadsolana.com)', network: 'Solana' },
  { id: 'GIGGLE-1808', symbol: 'GIGGLE', name: 'Giggle Fund', network: 'Other' },
  { id: 'GIZA-1668', symbol: 'GIZA', name: 'Giza', network: 'Other' },
  { id: 'GLCH-494', symbol: 'GLCH', name: 'Glitch', network: 'Other' },
  { id: 'GLDX-1927', symbol: 'GLDX', name: 'Gold tokenized ETF (xStock)', network: 'Other' },
  { id: 'GLIDR-1875', symbol: 'GLIDR', name: 'GLIDR', network: 'Other' },
  { id: 'GLM-507', symbol: 'GLM', name: 'Golem', network: 'Other' },
  { id: 'GLMR-771', symbol: 'GLMR', name: 'Moonbeam', network: 'Other' },
  { id: 'GME-496', symbol: 'GME', name: 'GmeStop', network: 'Other' },
  { id: 'GMEX-1901', symbol: 'GMEX', name: 'Gamestop tokenized stock (xStock)', network: 'Other' },
  { id: 'GMMT-486', symbol: 'GMMT', name: 'Giant Mammoth', network: 'Other' },
  { id: 'GMT-497', symbol: 'GMT', name: 'GMT', network: 'Other' },
  { id: 'GMX-498', symbol: 'GMX', name: 'GMX', network: 'Other' },
  { id: 'GNCO-1874', symbol: 'GNCO', name: 'GANCHO', network: 'Other' },
  { id: 'GNO-499', symbol: 'GNO', name: 'Gnosis', network: 'Other' },
  { id: 'GNS-464', symbol: 'GNS', name: 'Gains Network', network: 'Other' },
  { id: 'GO-501', symbol: 'GO', name: 'GoChain', network: 'Other' },
  { id: 'GOAT-500', symbol: 'GOAT', name: 'Goatseus Maximus', network: 'Other' },
  { id: 'GODL-1023', symbol: 'GODL', name: 'RoOLZ', network: 'Other' },
  { id: 'GODS-502', symbol: 'GODS', name: 'Gods Unchained', network: 'Other' },
  { id: 'GOG-524', symbol: 'GOG', name: 'Guild of Guardians', network: 'Other' },
  { id: 'GOMINING-509', symbol: 'GOMINING', name: 'GoMining', network: 'Other' },
  { id: 'GOOGLON-1957', symbol: 'GOOGLON', name: 'Alphabet Class A Tokenized Stock (Ondo)', network: 'Other' },
  { id: 'GOOGLX-1530', symbol: 'GOOGLX', name: 'Alphabet tokenized stock', network: 'Other' },
  { id: 'GOR-1550', symbol: 'GOR', name: 'Gorbagana', network: 'Other' },
  { id: 'GORK-1541', symbol: 'GORK', name: 'New XAI gork', network: 'Other' },
  { id: 'GPS-1405', symbol: 'GPS', name: 'GoPlus Security', network: 'Other' },
  { id: 'GRABON-1949', symbol: 'GRABON', name: 'Grab Holdings Tokenized Stock (Ondo)', network: 'Other' },
  { id: 'GRASS-515', symbol: 'GRASS', name: 'Grass', network: 'Other' },
  { id: 'GRIFFAIN-1461', symbol: 'GRIFFAIN', name: 'GRIFFAIN', network: 'Other' },
  { id: 'GRS-520', symbol: 'GRS', name: 'Groestlcoin', network: 'Other' },
  { id: 'GRT-1190', symbol: 'GRT', name: 'The Graph', network: 'Other' },
  { id: 'GSWIFT-478', symbol: 'GSWIFT', name: 'GameSwift', network: 'Other' },
  { id: 'GT-1406', symbol: 'GT', name: 'GateToken', network: 'Other' },
  { id: 'GTAI-522', symbol: 'GTAI', name: 'GT Protocol', network: 'Other' },
  { id: 'GTC-493', symbol: 'GTC', name: 'Gitcoin', network: 'Other' },
  { id: 'GUN-1462', symbol: 'GUN', name: 'GUNZ', network: 'Other' },
  { id: 'GWEI-1980', symbol: 'GWEI', name: 'ETHGas', network: 'Other' },
  { id: 'GXC-527', symbol: 'GXC', name: 'GXChain', network: 'Other' },
  { id: 'H-1507', symbol: 'H', name: 'Humanity Protocol', network: 'Other' },
  { id: 'H2O-528', symbol: 'H2O', name: 'H2O Dao', network: 'Other' },
  { id: 'HAEDAL-1463', symbol: 'HAEDAL', name: 'Haedal Protocol', network: 'Other' },
  { id: 'HANA-1790', symbol: 'HANA', name: 'Hana Network', network: 'Other' },
  { id: 'HAPPY-1407', symbol: 'HAPPY', name: 'Happy Cat', network: 'Other' },
  { id: 'HART-530', symbol: 'HART', name: 'Hara Token', network: 'Other' },
  { id: 'HBAR-538', symbol: 'HBAR', name: 'Hedera', network: 'Other' },
  { id: 'HBD-553', symbol: 'HBD', name: 'Hive Dollar', network: 'Other' },
  { id: 'HEI-541', symbol: 'HEI', name: 'Heima', network: 'Other' },
  { id: 'HEMI-1746', symbol: 'HEMI', name: 'Hemi', network: 'Other' },
  { id: 'HFT-535', symbol: 'HFT', name: 'Hashflow', network: 'Other' },
  { id: 'HIFI-547', symbol: 'HIFI', name: 'Hifi Finance', network: 'Other' },
  { id: 'HIGH-549', symbol: 'HIGH', name: 'Highstreet', network: 'Other' },
  { id: 'HIPPO-1142', symbol: 'HIPPO', name: 'sudeng', network: 'Other' },
  { id: 'HIVE-552', symbol: 'HIVE', name: 'Hive', network: 'Other' },
  { id: 'HMSTR-529', symbol: 'HMSTR', name: 'Hamster Kombat', network: 'Other' },
  { id: 'HNST-559', symbol: 'HNST', name: 'Honest', network: 'Other' },
  { id: 'HNT-542', symbol: 'HNT', name: 'Helium', network: 'Other' },
  { id: 'HOLD-556', symbol: 'HOLD', name: 'Holdstation', network: 'Other' },
  { id: 'HOLO-1765', symbol: 'HOLO', name: 'Holoworld AI', network: 'Other' },
  { id: 'HOME-1506', symbol: 'HOME', name: 'Defi App', network: 'Other' },
  { id: 'HONEY-554', symbol: 'HONEY', name: 'Hivemapper', network: 'Other' },
  { id: 'HONX-1968', symbol: 'HONX', name: 'Honeywell Tokenized Stock (xStock)', network: 'Other' },
  { id: 'HOODON-1931', symbol: 'HOODON', name: 'Robinhood Markets Tokenized Stock (Ondo)', network: 'Other' },
  { id: 'HOODX-1538', symbol: 'HOODX', name: 'Robinhood tokenized stock', network: 'Other' },
  { id: 'HOOK-560', symbol: 'HOOK', name: 'Hooked Protocol', network: 'Other' },
  { id: 'HOPPY-561', symbol: 'HOPPY', name: 'Hoppy', network: 'Other' },
  { id: 'HOT-557', symbol: 'HOT', name: 'Holo', network: 'Other' },
  { id: 'HOUSE-1540', symbol: 'HOUSE', name: 'Housecoin', network: 'Other' },
  { id: 'HPP-1997', symbol: 'HPP', name: 'House Party Protocol', network: 'Other' },
  { id: 'HTX-562', symbol: 'HTX', name: 'HTX', network: 'Other' },
  { id: 'HUMA-1464', symbol: 'HUMA', name: 'Huma Finance', network: 'Other' },
  { id: 'HYPE-1408', symbol: 'HYPE', name: 'Hyperliquid', network: 'Other' },
  { id: 'HYPER-1465', symbol: 'HYPER', name: 'Hyperlane', network: 'Other' },
  { id: 'IAG-566', symbol: 'IAG', name: 'IAGON', network: 'Other' },
  { id: 'IAUON-1924', symbol: 'IAUON', name: 'iShares Gold Trust Tokenized ETF (Ondo)', network: 'Other' },
  { id: 'ICE-567', symbol: 'ICE', name: 'Ice Open Network', network: 'Other' },
  { id: 'ICNT-1589', symbol: 'ICNT', name: 'Impossible Cloud Network', network: 'Other' },
  { id: 'ICP-583', symbol: 'ICP', name: 'Internet Computer', network: 'Other' },
  { id: 'ICX-568', symbol: 'ICX', name: 'ICON', network: 'Other' },
  { id: 'ID-1107', symbol: 'ID', name: 'SPACE ID', network: 'Other' },
  { id: 'IDDB-569', symbol: 'IDDB', name: 'ID Digital Bonds', network: 'Other' },
  { id: 'IDDR-570', symbol: 'IDDR', name: 'ID Digital Rupiah', network: 'Other' },
  { id: 'IDEX-571', symbol: 'IDEX', name: 'IDEX', network: 'Other' },
  { id: 'IDOL-1598', symbol: 'IDOL', name: 'MEET48', network: 'Other' },
  { id: 'IDRQ-1444', symbol: 'IDRQ', name: 'IDRQ', network: 'Other' },
  { id: 'IDRT-1032', symbol: 'IDRT', name: 'Rupiah Token', network: 'Other' },
  { id: 'IDRX-573', symbol: 'IDRX', name: 'IDRX', network: 'Other' },
  { id: 'IEFAON-1922', symbol: 'IEFAON', name: 'iShares Core MSCI EAFE Tokenized ETF (Ondo)', network: 'Other' },
  { id: 'IJHON-1923', symbol: 'IJHON', name: 'iShares Core S&P MidCap Tokenized ETF (Ondo)', network: 'Other' },
  { id: 'IKA-1669', symbol: 'IKA', name: 'IKA', network: 'Other' },
  { id: 'ILV-577', symbol: 'ILV', name: 'Illuvium', network: 'Other' },
  { id: 'IMU-1909', symbol: 'IMU', name: 'Immunefi', network: 'Other' },
  { id: 'IMX-578', symbol: 'IMX', name: 'Immutable', network: 'Other' },
  { id: 'IN-1708', symbol: 'IN', name: 'INFINIT', network: 'Other' },
  { id: 'INDAON-1988', symbol: 'INDAON', name: 'iShares MSCI India Tokenized ETF (Ondo)', network: 'Other' },
  { id: 'INDR-1806', symbol: 'INDR', name: 'INDR', network: 'Other' },
  { id: 'INIT-1466', symbol: 'INIT', name: 'Initia', network: 'Other' },
  { id: 'INJ-579', symbol: 'INJ', name: 'Injective', network: 'Other' },
  { id: 'INSP-580', symbol: 'INSP', name: 'Inspect', network: 'Other' },
  { id: 'INTER-582', symbol: 'INTER', name: 'Inter Milan Fan Token', network: 'Other' },
  { id: 'INX-1995', symbol: 'INX', name: 'Infinex', network: 'Other' },
  { id: 'IO-585', symbol: 'IO', name: 'io.net', network: 'Other' },
  { id: 'IOST-586', symbol: 'IOST', name: 'IOST', network: 'Other' },
  { id: 'IOTA-587', symbol: 'IOTA', name: 'IOTA', network: 'Other' },
  { id: 'IOTX-588', symbol: 'IOTX', name: 'IoTeX', network: 'Other' },
  { id: 'IP-1409', symbol: 'IP', name: 'Story', network: 'Other' },
  { id: 'IQ-589', symbol: 'IQ', name: 'IQ', network: 'Other' },
  { id: 'ISLM-592', symbol: 'ISLM', name: 'Islamic Coin', network: 'Other' },
  { id: 'IVVON-1893', symbol: 'IVVON', name: 'iShares Core S&P 500 Tokenized ETF (Ondo)', network: 'Other' },
  { id: 'IWMON-1960', symbol: 'IWMON', name: 'iShares Russell 2000 Tokenized ETF (Ondo)', network: 'Other' },
  { id: 'IZI-594', symbol: 'IZI', name: 'Izumi Finance', network: 'Other' },
  { id: 'JASMY-595', symbol: 'JASMY', name: 'JasmyCoin', network: 'Other' },
  { id: 'JCT-1857', symbol: 'JCT', name: 'Janction', network: 'Other' },
  { id: 'JELLYJELLY-1467', symbol: 'JELLYJELLY', name: 'Jelly-My-Jelly', network: 'Other' },
  { id: 'JOE-599', symbol: 'JOE', name: 'JOE', network: 'Other' },
  { id: 'JPMON-1885', symbol: 'JPMON', name: 'JPMorgan Chase Tokenized Stock (Ondo)', network: 'Other' },
  { id: 'JST-602', symbol: 'JST', name: 'JUST', network: 'Other' },
  { id: 'JTO-598', symbol: 'JTO', name: 'Jito', network: 'Other' },
  { id: 'JUP-601', symbol: 'JUP', name: 'Jupiter', network: 'Other' },
  { id: 'JUV-604', symbol: 'JUV', name: 'Juventus Fan token', network: 'Other' },
  { id: 'K-1819', symbol: 'K', name: 'Sidekick', network: 'Other' },
  { id: 'KAIA-606', symbol: 'KAIA', name: 'Kaia', network: 'Kaia' },
  { id: 'KAITO-1410', symbol: 'KAITO', name: 'KAITO', network: 'Other' },
  { id: 'KAS-611', symbol: 'KAS', name: 'Kaspa', network: 'Other' },
  { id: 'KASTA-612', symbol: 'KASTA', name: 'Kasta', network: 'Other' },
  { id: 'KAT-1972', symbol: 'KAT', name: 'Katana Network', network: 'Other' },
  { id: 'KAVA-614', symbol: 'KAVA', name: 'Kava', network: 'Other' },
  { id: 'KCS-638', symbol: 'KCS', name: 'KuCoin Token', network: 'Other' },
  { id: 'KDAG-620', symbol: 'KDAG', name: 'King DAG', network: 'Other' },
  { id: 'KERNEL-1411', symbol: 'KERNEL', name: 'KernelDAO', network: 'Other' },
  { id: 'KGEN-1836', symbol: 'KGEN', name: 'KGeN', network: 'Other' },
  { id: 'KILO-1469', symbol: 'KILO', name: 'KiloEx', network: 'Other' },
  { id: 'KIN-619', symbol: 'KIN', name: 'Kin', network: 'Other' },
  { id: 'KITE-1828', symbol: 'KITE', name: 'Kite', network: 'Other' },
  { id: 'KLV-625', symbol: 'KLV', name: 'Klever Coin', network: 'Other' },
  { id: 'KMNO-607', symbol: 'KMNO', name: 'Kamino Finance', network: 'Other' },
  { id: 'KNC-642', symbol: 'KNC', name: 'Kyber Network Crystal v2', network: 'Other' },
  { id: 'KOM-630', symbol: 'KOM', name: 'Kommunitas', network: 'Other' },
  { id: 'KOMA-1412', symbol: 'KOMA', name: 'Koma inu', network: 'Other' },
  { id: 'KOON-1963', symbol: 'KOON', name: 'Coca-Cola Tokenized Stock (Ondo)', network: 'Other' },
  { id: 'KRD-635', symbol: 'KRD', name: 'Krypton DAO', network: 'Other' },
  { id: 'KSM-640', symbol: 'KSM', name: 'Kusama', network: 'Other' },
  { id: 'KTA-1709', symbol: 'KTA', name: 'Keeta', network: 'Other' },
  { id: 'KUB-637', symbol: 'KUB', name: 'Kub Coin', network: 'Other' },
  { id: 'KUMA-1872', symbol: 'KUMA', name: 'Captain Kuma', network: 'Other' },
  { id: 'KUNCI-639', symbol: 'KUNCI', name: 'Kunci Coin', network: 'Other' },
  { id: 'L3-648', symbol: 'L3', name: 'Layer3', network: 'Other' },
  { id: 'LA-1525', symbol: 'LA', name: 'Lagrange', network: 'Other' },
  { id: 'LAB-1992', symbol: 'LAB', name: 'LAB', network: 'Other' },
  { id: 'LABUBU-1592', symbol: 'LABUBU', name: 'LABUBU', network: 'Other' },
  { id: 'LADYS-749', symbol: 'LADYS', name: 'Milady Meme Coin', network: 'Other' },
  { id: 'LAT-935', symbol: 'LAT', name: 'PlatON', network: 'Other' },
  { id: 'LAUNCHCOIN-1470', symbol: 'LAUNCHCOIN', name: 'Launch Coin on Believe', network: 'Other' },
  { id: 'LAYER-1242', symbol: 'LAYER', name: 'UniLayer', network: 'Other' },
  { id: 'LAZIO-1034', symbol: 'LAZIO', name: 'S.S. Lazio Fan Token', network: 'Other' },
  { id: 'LBR-686', symbol: 'LBR', name: 'Lybra Finance', network: 'Other' },
  { id: 'LBTC-1850', symbol: 'LBTC', name: 'Lombard Staked BTC', network: 'Other' },
  { id: 'LDO-658', symbol: 'LDO', name: 'Lido DAO', network: 'Other' },
  { id: 'LEO-1248', symbol: 'LEO', name: 'UNUS SED LEO', network: 'Other' },
  { id: 'LEVER-656', symbol: 'LEVER', name: 'LeverFi', network: 'Other' },
  { id: 'LFT-660', symbol: 'LFT', name: 'Lifeform Token', network: 'Other' },
  { id: 'LGCT-1777', symbol: 'LGCT', name: 'Legacy', network: 'Other' },
  { id: 'LIF3-659', symbol: 'LIF3', name: 'LIF3', network: 'Other' },
  { id: 'LIGHT-1793', symbol: 'LIGHT', name: 'Bitlight Labs', network: 'Other' },
  { id: 'LINEA-1750', symbol: 'LINEA', name: 'Linea', network: 'Other' },
  { id: 'LINK-248', symbol: 'LINK', name: 'Chainlink', network: 'Other' },
  { id: 'LISTA-672', symbol: 'LISTA', name: 'Lista DAO', network: 'Other' },
  { id: 'LIT-1878', symbol: 'LIT', name: 'Lighter', network: 'Other' },
  { id: 'LIVE-1871', symbol: 'LIVE', name: 'LIVE', network: 'Other' },
  { id: 'LL-662', symbol: 'LL', name: 'LightLink', network: 'Other' },
  { id: 'LLYON-1855', symbol: 'LLYON', name: 'ELI LILLY TOKENIZED STOCK (ONDO)', network: 'Other' },
  { id: 'LLYX-1702', symbol: 'LLYX', name: 'Eli Lilly tokenized stock', network: 'Other' },
  { id: 'LMTON-1977', symbol: 'LMTON', name: 'Lockheed Tokenized Stock (Ondo)', network: 'Other' },
  { id: 'LMWR-664', symbol: 'LMWR', name: 'LimeWire', network: 'Other' },
  { id: 'LNQ-669', symbol: 'LNQ', name: 'LinqAI', network: 'Other' },
  { id: 'LOOKS-678', symbol: 'LOOKS', name: 'LooksRare', network: 'Other' },
  { id: 'LOOM-679', symbol: 'LOOM', name: 'Loom Network', network: 'Other' },
  { id: 'LPT-676', symbol: 'LPT', name: 'Livepeer', network: 'Other' },
  { id: 'LQTY-670', symbol: 'LQTY', name: 'Liquity', network: 'Other' },
  { id: 'LRC-680', symbol: 'LRC', name: 'Loopring', network: 'Other' },
  { id: 'LRDS-184', symbol: 'LRDS', name: 'BLOCKLORDS', network: 'Other' },
  { id: 'LSK-671', symbol: 'LSK', name: 'Lisk', network: 'Other' },
  { id: 'LTC-673', symbol: 'LTC', name: 'Litecoin', network: 'Other' },
  { id: 'LTO-682', symbol: 'EQTY', name: 'EQTY', network: 'Other' },
  { id: 'LUMIA-684', symbol: 'LUMIA', name: 'Lumia', network: 'Other' },
  { id: 'LUNA-1182', symbol: 'LUNA', name: 'Terra', network: 'Other' },
  { id: 'LUNC-1183', symbol: 'LUNC', name: 'Terra Classic', network: 'Other' },
  { id: 'LUNIOX-1414', symbol: 'LUNIOX', name: 'LunioX', network: 'Other' },
  { id: 'LWA-685', symbol: 'LWA', name: 'LumiWave', network: 'Other' },
  { id: 'LYFE-687', symbol: 'LYFE', name: 'Lyfe', network: 'Other' },
  { id: 'LYX-683', symbol: 'LYX', name: 'LUKSO', network: 'Other' },
  { id: 'M-1599', symbol: 'M', name: 'MemeCore', network: 'Other' },
  { id: 'MAGIC-1218', symbol: 'MAGIC', name: 'Treasure', network: 'Other' },
  { id: 'MAGMA-1881', symbol: 'MAGMA', name: 'Magma Finance', network: 'Other' },
  { id: 'MAJOR-1447', symbol: 'MAJOR', name: 'MAJOR', network: 'Other' },
  { id: 'MANA-324', symbol: 'MANA', name: 'Decentraland', network: 'Other' },
  { id: 'MANGO-1655', symbol: 'MANGO', name: 'Mango Network', network: 'Other' },
  { id: 'MANTA-698', symbol: 'MANTA', name: 'Manta Network', network: 'Other' },
  { id: 'MANTRA-1958', symbol: 'MANTRA', name: 'Mantra', network: 'Other' },
  { id: 'MAON-1758', symbol: 'MAON', name: 'Mastercard Tokenized Stock (Ondo)', network: 'Other' },
  { id: 'MAPO-702', symbol: 'MAPO', name: 'MAP Protocol', network: 'Other' },
  { id: 'MAS-711', symbol: 'MAS', name: 'Massa', network: 'Other' },
  { id: 'MASA-708', symbol: 'MASA', name: 'Masa', network: 'Other' },
  { id: 'MASK-710', symbol: 'MASK', name: 'Mask Network', network: 'Other' },
  { id: 'MAT-1597', symbol: 'MAT', name: 'Matchain', network: 'Other' },
  { id: 'MATH-712', symbol: 'MATH', name: 'MATH', network: 'Other' },
  { id: 'MAV-715', symbol: 'MAV', name: 'Maverick Protocol', network: 'Other' },
  { id: 'MAVIA-545', symbol: 'MAVIA', name: 'Heroes of Mavia', network: 'Other' },
  { id: 'MAX-713', symbol: 'MAX', name: 'Matr1x', network: 'Other' },
  { id: 'MBG-1714', symbol: 'MBG', name: 'MultiBank Group', network: 'Other' },
  { id: 'MBL-783', symbol: 'MBL', name: 'MovieBloc', network: 'Other' },
  { id: 'MBOX-763', symbol: 'MBOX', name: 'MOBOX', network: 'Other' },
  { id: 'MBX-704', symbol: 'MBX', name: 'Marblex', network: 'Other' },
  { id: 'MCADE-731', symbol: 'MCADE', name: 'Metacade', network: 'Other' },
  { id: 'MCDON-1937', symbol: 'MCDON', name: 'McDonalds Tokenized Stock (Ondo)', network: 'Other' },
  { id: 'MCDX-1712', symbol: 'MCDX', name: 'McDonalds tokenized Stocks', network: 'Other' },
  { id: 'MCRT-692', symbol: 'MCRT', name: 'MagicCraft', network: 'Other' },
  { id: 'MCT-733', symbol: 'MCT', name: 'Metacraft', network: 'Other' },
  { id: 'MDAO-707', symbol: 'MDAO', name: 'MarsDAO', network: 'Other' },
  { id: 'MDT-719', symbol: 'MDT', name: 'Measurable Data Token', network: 'Other' },
  { id: 'ME-691', symbol: 'ME', name: 'Magic Eden', network: 'Other' },
  { id: 'MEE-722', symbol: 'MEE', name: 'Medieval Empires', network: 'Other' },
  { id: 'MEGA-1890', symbol: 'MEGA', name: 'MegaETH', network: 'Other' },
  { id: 'MELANIA-1418', symbol: 'MELANIA', name: 'Official Melania Meme', network: 'Other' },
  { id: 'MEME-725', symbol: 'MEME', name: 'Memecoin', network: 'Other' },
  { id: 'MEMEFI-1600', symbol: 'MEMEFI', name: 'MemeFi', network: 'Other' },
  { id: 'MERL-727', symbol: 'MERL', name: 'Merlin Chain', network: 'Other' },
  { id: 'MET-1767', symbol: 'MET', name: 'Meteora', network: 'Other' },
  { id: 'MET-1779', symbol: 'MY', name: 'MetYa', network: 'Other' },
  { id: 'META-734', symbol: 'META', name: 'Metadium', network: 'Other' },
  { id: 'METAON-1925', symbol: 'METAON', name: 'Meta Tokenized Stock (Ondo)', network: 'Other' },
  { id: 'METAX-1534', symbol: 'METAX', name: 'Meta tokenized stock', network: 'Other' },
  { id: 'METH-700', symbol: 'METH', name: 'Mantle Staked Ether', network: 'Ethereum' },
  { id: 'METIS-742', symbol: 'METIS', name: 'Metis', network: 'Other' },
  { id: 'MEW-228', symbol: 'MEW', name: 'cat in a dogs world', network: 'Other' },
  { id: 'MGO-1547', symbol: 'MGO', name: 'Meta GO', network: 'Other' },
  { id: 'MIGGLES-784', symbol: 'MIGGLES', name: 'Mr Miggles', network: 'Other' },
  { id: 'MILK-1475', symbol: 'MILK', name: 'MilkyWay', network: 'Other' },
  { id: 'MINA-750', symbol: 'MINA', name: 'Mina', network: 'Other' },
  { id: 'MIRA-1792', symbol: 'MIRA', name: 'Mira', network: 'Other' },
  { id: 'MIRA-755', symbol: 'MIRA', name: 'MIRA', network: 'Other' },
  { id: 'MITO-1713', symbol: 'MITO', name: 'Mitosis', network: 'Other' },
  { id: 'ML-753', symbol: 'ML', name: 'Mintlayer', network: 'Other' },
  { id: 'MLK-748', symbol: 'MLK', name: 'MiL.k', network: 'Other' },
  { id: 'MLN-411', symbol: 'MLN', name: 'Enzyme', network: 'Other' },
  { id: 'MMT-1817', symbol: 'MMT', name: 'Momentum', network: 'Other' },
  { id: 'MNT-699', symbol: 'MNT', name: 'Mantle', network: 'Other' },
  { id: 'MOBILE-543', symbol: 'MOBILE', name: 'Helium Mobile', network: 'Other' },
  { id: 'MOCA-764', symbol: 'MOCA', name: 'Moca Network', network: 'Other' },
  { id: 'MODE-765', symbol: 'MODE', name: 'Mode', network: 'Other' },
  { id: 'MOEW-369', symbol: 'MOEW', name: 'donotfomoew', network: 'Other' },
  { id: 'MOG-766', symbol: 'MOG', name: 'Mog Coin', network: 'Other' },
  { id: 'MOLT-1952', symbol: 'MOLT', name: 'Moltbook', network: 'Other' },
  { id: 'MON-767', symbol: 'MONPRO', name: 'MON', network: 'Other' },
  { id: 'MONAD-1752', symbol: 'MONAD', name: 'Monad', network: 'Other' },
  { id: 'MOODENG-770', symbol: 'MOODENG', name: 'Moo Deng (moodengsol.com)', network: 'Other' },
  { id: 'MOONPIG-1477', symbol: 'MOONPIG', name: 'moonpig', network: 'Other' },
  { id: 'MORE-1602', symbol: 'MORE', name: 'Moonveil', network: 'Other' },
  { id: 'MORPHO-777', symbol: 'MORPHO', name: 'Morpho', network: 'Other' },
  { id: 'MOTHER-779', symbol: 'MOTHER', name: 'Mother Iggy', network: 'Other' },
  { id: 'MOVE-780', symbol: 'MOVE', name: 'Movement', network: 'Other' },
  { id: 'MOVR-775', symbol: 'MOVR', name: 'Moonriver', network: 'Other' },
  { id: 'MOZ-1595', symbol: 'MOZ', name: 'Lumoz', network: 'Other' },
  { id: 'MPLX-739', symbol: 'MPLX', name: 'Metaplex', network: 'Other' },
  { id: 'MPRO-717', symbol: 'MPRO', name: 'Max Property', network: 'Other' },
  { id: 'MRS-740', symbol: 'MRS', name: 'Metars Genesis', network: 'Other' },
  { id: 'MSFTON-1762', symbol: 'MSFTON', name: 'Microsoft Tokenized Stock (Ondo)', network: 'Other' },
  { id: 'MSFTX-1981', symbol: 'MSFTX', name: 'Microsoft tokenized stock (xStock)', network: 'Other' },
  { id: 'MSHD-709', symbol: 'MSHD', name: 'MASHIDA', network: 'Other' },
  { id: 'MSTRON-1928', symbol: 'MSTRON', name: 'MicroStrategy Tokenized Stock (Ondo)', network: 'Other' },
  { id: 'MSTRX-1535', symbol: 'MSTRX', name: 'MicroStrategy tokenized stock', network: 'Other' },
  { id: 'MTC-773', symbol: 'MTC', name: 'Moonft', network: 'Other' },
  { id: 'MTL-737', symbol: 'MTL', name: 'Metal DAO', network: 'Other' },
  { id: 'MUBARAK-1603', symbol: 'MUBARAK', name: 'Mubarak', network: 'Other' },
  { id: 'MUBI-785', symbol: 'MUBI', name: 'Multibit', network: 'Other' },
  { id: 'MULTI-786', symbol: 'MULTI', name: 'Multichain', network: 'Other' },
  { id: 'MUON-1965', symbol: 'MUON', name: 'Micron Technology Tokenized Stock (Ondo)', network: 'Other' },
  { id: 'MURA-788', symbol: 'MURA', name: 'Murasaki', network: 'Other' },
  { id: 'MV-485', symbol: 'MV', name: 'GensoKishi Metaverse', network: 'Other' },
  { id: 'MVL-789', symbol: 'MVL', name: 'MVL', network: 'Other' },
  { id: 'MVP-1905', symbol: 'MVP', name: 'Crypstocks AI', network: 'Other' },
  { id: 'MX-790', symbol: 'MX', name: 'MX Token', network: 'Other' },
  { id: 'MYRIA-793', symbol: 'MYRIA', name: 'Myria', network: 'Other' },
  { id: 'MYRO-794', symbol: 'MYRO', name: 'Myro', network: 'Other' },
  { id: 'MYX-1604', symbol: 'MYX', name: 'MYX Finance', network: 'Other' },
  { id: 'NAKA-796', symbol: 'NAKA', name: 'Nakamoto Games', network: 'Other' },
  { id: 'NAORIS-1673', symbol: 'NAORIS', name: 'Naoris Protocol', network: 'Other' },
  { id: 'NAP-800', symbol: 'NAP', name: 'Napoli Fan token', network: 'Other' },
  { id: 'NAVX-802', symbol: 'NAVX', name: 'NAVI Protocol', network: 'Other' },
  { id: 'NBT-799', symbol: 'NBT', name: 'NanoByte Token', network: 'Other' },
  { id: 'NC-1606', symbol: 'NC', name: 'Nodecoin', network: 'Other' },
  { id: 'NEAR-803', symbol: 'NEAR', name: 'NEAR Protocol', network: 'Other' },
  { id: 'NEIRO-805', symbol: 'NEIRO', name: 'Neiro (First Neiro On Ethereum)', network: 'Ethereum' },
  { id: 'NEO-807', symbol: 'NEO', name: 'Neo', network: 'Other' },
  { id: 'NEOIDR-808', symbol: 'NEOIDR', name: 'NEOIDR', network: 'Other' },
  { id: 'NEON-809', symbol: 'NEON', name: 'Neon EVM', network: 'Other' },
  { id: 'NESS-812', symbol: 'NESS', name: 'Ness LAB', network: 'Other' },
  { id: 'NEWT-1509', symbol: 'NEWT', name: 'Newton Protocol', network: 'Other' },
  { id: 'NEXA-820', symbol: 'NEXA', name: 'Nexa', network: 'Other' },
  { id: 'NEXO-821', symbol: 'NEXO', name: 'Nexo', network: 'Other' },
  { id: 'NFLXON-1757', symbol: 'NFLXON', name: 'Netflix Tokenized Stock (Ondo)', network: 'Other' },
  { id: 'NFP-823', symbol: 'NFP', name: 'NFPrompt', network: 'Other' },
  { id: 'NFT-1882', symbol: 'NFT', name: 'NEFTiPEDIA', network: 'Other' },
  { id: 'NFT-804', symbol: 'NFT', name: 'AINFT', network: 'Other' },
  { id: 'NIBI-824', symbol: 'NIBI', name: 'Nibiru Chain', network: 'Other' },
  { id: 'NIGHT-1884', symbol: 'NIGHT', name: 'Midnight', network: 'Other' },
  { id: 'NIKLON-1916', symbol: 'NIKLON', name: 'Sprott Nickel Miners Tokenized ETF (Ondo)', network: 'Other' },
  { id: 'NIL-1523', symbol: 'NIL', name: 'Nillion', network: 'Other' },
  { id: 'NKN-825', symbol: 'NKN', name: 'NKN', network: 'Other' },
  { id: 'NMD-1498', symbol: 'NMD', name: 'Nexusmind', network: 'Other' },
  { id: 'NMR-836', symbol: 'NMR', name: 'Numeraire', network: 'Other' },
  { id: 'NMT-813', symbol: 'NMT', name: 'NetMind Token', network: 'Other' },
  { id: 'NOBODY-1715', symbol: 'NOBODY', name: 'Nobody Sausage', network: 'Other' },
  { id: 'NODE-1510', symbol: 'NODE', name: 'NodeOps', network: 'Other' },
  { id: 'NOM-1748', symbol: 'NOM', name: 'Nomina', network: 'Other' },
  { id: 'NOT-830', symbol: 'NOT', name: 'Notcoin', network: 'Other' },
  { id: 'NOVA-1809', symbol: 'NOVA', name: 'NOVA', network: 'Other' },
  { id: 'NPC-827', symbol: 'NPC', name: 'Non-Playable Coin', network: 'Other' },
  { id: 'NRG-407', symbol: 'NRG', name: 'Energi', network: 'Other' },
  { id: 'NRN-816', symbol: 'NRN', name: 'Neuron', network: 'Other' },
  { id: 'NS-1417', symbol: 'NS', name: 'Sui Name Service', network: 'Other' },
  { id: 'NTRN-817', symbol: 'NTRN', name: 'Neutron', network: 'Tron' },
  { id: 'NUM-835', symbol: 'NUM', name: 'Numbers Protocol', network: 'Other' },
  { id: 'NUSA-837', symbol: 'NUSA', name: 'NUSA', network: 'Other' },
  { id: 'NVDAON-1951', symbol: 'NVDAON', name: 'NVIDIA Tokenized Stock (Ondo)', network: 'Other' },
  { id: 'NVDAX-1537', symbol: 'NVDAX', name: 'NVIDIA tokenized stock', network: 'Other' },
  { id: 'NVGLDN-1656', symbol: 'NVGLDN', name: 'Golden', network: 'Other' },
  { id: 'NVOON-1935', symbol: 'NVOON', name: 'Novo Nordisk Tokenized Stock (Ondo)', network: 'Other' },
  { id: 'NXA-1838', symbol: 'NXA', name: 'Nexa (nexaagent.xyz)', network: 'Other' },
  { id: 'NXPC-1478', symbol: 'NXPC', name: 'Nexpace', network: 'Other' },
  { id: 'NYAN-840', symbol: 'NYAN', name: 'Nyan Heroes', network: 'Other' },
  { id: 'NYM-1607', symbol: 'NYM', name: 'NYM', network: 'Other' },
  { id: 'OAS-842', symbol: 'OAS', name: 'Oasys', network: 'Other' },
  { id: 'OBI-1847', symbol: 'OBI', name: 'Orbofi AI', network: 'Other' },
  { id: 'OBOL-1522', symbol: 'OBOL', name: 'Obol', network: 'Other' },
  { id: 'OBT-1511', symbol: 'OBT', name: 'Orbiter Finance', network: 'Other' },
  { id: 'OCEAN-846', symbol: 'OCEAN', name: 'Ocean Protocol', network: 'Other' },
  { id: 'ODOS-1608', symbol: 'ODOS', name: 'ODOS', network: 'Other' },
  { id: 'OG-849', symbol: 'OG', name: 'OG Fan Token', network: 'Other' },
  { id: 'OGN-889', symbol: 'OGN', name: 'Origin Protocol', network: 'Other' },
  { id: 'OIK-1627', symbol: 'OIK', name: 'Space Nation Oikos', network: 'Other' },
  { id: 'OKB-851', symbol: 'OKB', name: 'OKB', network: 'Other' },
  { id: 'OKUSD-1675', symbol: 'OKUSD', name: 'OKUSD', network: 'Other' },
  { id: 'OL-1610', symbol: 'OL', name: 'Openloot', network: 'Other' },
  { id: 'OM-701', symbol: 'OM', name: 'MANTRA', network: 'Other' },
  { id: 'OMG-856', symbol: 'OMG', name: 'OMG Network', network: 'Other' },
  { id: 'OMI-389', symbol: 'OMI', name: 'ECOMI', network: 'Other' },
  { id: 'OMNI-857', symbol: 'OMNI', name: 'Omni Network', network: 'Other' },
  { id: 'ONDO-861', symbol: 'ONDO', name: 'Ondo', network: 'Other' },
  { id: 'ONDSON-1932', symbol: 'ONDSON', name: 'Ondas Tokenized Stock (Ondo)', network: 'Other' },
  { id: 'ONE-531', symbol: 'ONE', name: 'Harmony', network: 'Other' },
  { id: 'ONG-863', symbol: 'ONG', name: 'Ontology Gas', network: 'Other' },
  { id: 'ONT-862', symbol: 'ONT', name: 'Ontology', network: 'Other' },
  { id: 'OORT-867', symbol: 'OORT', name: 'OORT', network: 'Other' },
  { id: 'OP-875', symbol: 'OP', name: 'Optimism', network: 'Other' },
  { id: 'OPEN-1747', symbol: 'OPEN', name: 'OpenLedger', network: 'Other' },
  { id: 'OPEN-869', symbol: 'OPEN', name: 'Open Custody Protocol', network: 'Other' },
  { id: 'ORAI-877', symbol: 'ORAI', name: 'Oraichain', network: 'Other' },
  { id: 'ORBS-882', symbol: 'ORBS', name: 'Orbs', network: 'Other' },
  { id: 'ORC-880', symbol: 'ORC', name: 'Orbit Chain', network: 'Other' },
  { id: 'ORCA-883', symbol: 'ORCA', name: 'Orca', network: 'Other' },
  { id: 'ORCLON-1953', symbol: 'ORCLON', name: 'Oracle Tokenized Stock (Ondo)', network: 'Other' },
  { id: 'ORDER-885', symbol: 'ORDER', name: 'Orderly Network', network: 'Other' },
  { id: 'ORDI-886', symbol: 'ORDI', name: 'Ordi', network: 'Other' },
  { id: 'ORT-852', symbol: 'ORT', name: 'Okratech Token', network: 'Other' },
  { id: 'OSMO-891', symbol: 'OSMO', name: 'Osmosis', network: 'Other' },
  { id: 'OXT-884', symbol: 'OXT', name: 'Orchid', network: 'Other' },
  { id: 'P-1794', symbol: 'P', name: 'PoP Planet', network: 'Other' },
  { id: 'PAAL-892', symbol: 'PAAL', name: 'PAAL AI', network: 'Other' },
  { id: 'PALLON-1912', symbol: 'PALLON', name: 'abrdn Physical Palladium Shares Tokenized ETF (Ondo)', network: 'Other' },
  { id: 'PARTI-1479', symbol: 'PARTI', name: 'Particle Network', network: 'Other' },
  { id: 'PAWS-1480', symbol: 'PAWS', name: 'PAWS', network: 'Other' },
  { id: 'PAXG-907', symbol: 'PAXG', name: 'PAX Gold', network: 'Other' },
  { id: 'PAYAI-1818', symbol: 'PAYAI', name: 'PayAI Network', network: 'Other' },
  { id: 'PCI-1613', symbol: 'PCI', name: 'Paycoin', network: 'Other' },
  { id: 'PEAQ-1614', symbol: 'PEAQ', name: 'Peaq', network: 'Other' },
  { id: 'PEIPEI-911', symbol: 'PEIPEI', name: 'PeiPei (ETH)', network: 'Other' },
  { id: 'PELL-1615', symbol: 'PELL', name: 'Pell Network Token', network: 'Other' },
  { id: 'PENDLE-913', symbol: 'PENDLE', name: 'Pendle', network: 'Other' },
  { id: 'PENGU-1419', symbol: 'PENGU', name: 'Pudgy Penguins', network: 'Other' },
  { id: 'PENGUIN-1943', symbol: 'PENGUIN', name: 'Nietzschean Penguin', network: 'Other' },
  { id: 'PEOPLE-276', symbol: 'PEOPLE', name: 'ConstitutionDAO', network: 'Other' },
  { id: 'PEPE-915', symbol: 'PEPE', name: 'Pepe', network: 'Other' },
  { id: 'PEPON-1756', symbol: 'PEPON', name: 'PepsiCo Tokenized Stock (Ondo)', network: 'Other' },
  { id: 'PERP-920', symbol: 'PERP', name: 'Perpetual Protocol', network: 'Other' },
  { id: 'PGON-1962', symbol: 'PGON', name: 'Procter & Gamble Tokenized Stock (Ondo)', network: 'Other' },
  { id: 'PHA-922', symbol: 'PHA', name: 'Phala Network', network: 'Other' },
  { id: 'PHB-925', symbol: 'PHB', name: 'Phoenix', network: 'Other' },
  { id: 'PHIL-924', symbol: 'PHIL', name: 'Philtoken', network: 'Other' },
  { id: 'PHY-1664', symbol: 'PHY', name: 'DePHY', network: 'Other' },
  { id: 'PIEVERSE-1870', symbol: 'PIEVERSE', name: 'Pieverse', network: 'Other' },
  { id: 'PIPPIN-1481', symbol: 'PIPPIN', name: 'PIPPIN', network: 'Other' },
  { id: 'PIRATE-929', symbol: 'PIRATE', name: 'Pirate Nation', network: 'Other' },
  { id: 'PIT-930', symbol: 'PIT', name: 'Pitbull', network: 'Other' },
  { id: 'PIVX-1359', symbol: 'PIVX', name: 'PIVX', network: 'Other' },
  { id: 'PIXEL-931', symbol: 'PIXEL', name: 'Pixels', network: 'Other' },
  { id: 'PIXFI-932', symbol: 'PIXFI', name: 'Pixelverse', network: 'Other' },
  { id: 'PLPA-893', symbol: 'PLPA', name: 'Palapa Token', network: 'Other' },
  { id: 'PLTRON-1760', symbol: 'PLTRON', name: 'Palantir Technologies Tokenized Stock (Ondo)', network: 'Other' },
  { id: 'PLUME-1421', symbol: 'PLUME', name: 'Plume Network', network: 'Other' },
  { id: 'PMX-1930', symbol: 'PMX', name: 'Philip Morris Tokenized Stock (xStock)', network: 'Other' },
  { id: 'PNUT-910', symbol: 'PNUT', name: 'Peanut the Squirrel', network: 'Other' },
  { id: 'POKT-942', symbol: 'POKT', name: 'Pocket Network', network: 'Other' },
  { id: 'POL-946', symbol: 'POL', name: 'Matic', network: 'Polygon' },
  { id: 'POLS-944', symbol: 'POLS', name: 'Polkastarter', network: 'Other' },
  { id: 'POLY-948', symbol: 'POLY', name: 'Polymath', network: 'Other' },
  { id: 'POLYX-949', symbol: 'POLYX', name: 'Polymesh', network: 'Other' },
  { id: 'POND-706', symbol: 'POND', name: 'Marlin', network: 'Other' },
  { id: 'PONKE-951', symbol: 'PONKE', name: 'Ponke', network: 'Other' },
  { id: 'POPCAT-952', symbol: 'POPCAT', name: 'Popcat (SOL)', network: 'Other' },
  { id: 'PORK-918', symbol: 'PORK', name: 'PepeFork', network: 'Other' },
  { id: 'PORT3-954', symbol: 'PORT3', name: 'Port3 Network', network: 'Other' },
  { id: 'PORTAL-955', symbol: 'PORTAL', name: 'Portal', network: 'Other' },
  { id: 'PORTO-437', symbol: 'PORTO', name: 'FC Porto Fan Token', network: 'Other' },
  { id: 'POWR-957', symbol: 'POWR', name: 'PowerLedger', network: 'Other' },
  { id: 'PRAI-1542', symbol: 'PRAI', name: 'Privasea AI', network: 'Other' },
  { id: 'PRCL-901', symbol: 'PRCL', name: 'Parcl', network: 'Other' },
  { id: 'PRIME-388', symbol: 'PRIME', name: 'Echelon Prime', network: 'Other' },
  { id: 'PRL-1990', symbol: 'PRL', name: 'Perle', network: 'Other' },
  { id: 'PRO-1720', symbol: 'PRO', name: 'Propy', network: 'Other' },
  { id: 'PROM-962', symbol: 'PROM', name: 'Prom', network: 'Other' },
  { id: 'PROMPT-1515', symbol: 'PROMPT', name: 'Wayfinder', network: 'Other' },
  { id: 'PROPC-964', symbol: 'PROPC', name: 'Propchain', network: 'Other' },
  { id: 'PROPS-963', symbol: 'PROPS', name: 'Propbase', network: 'Other' },
  { id: 'PROVE-1729', symbol: 'PROVE', name: 'Succinct', network: 'Other' },
  { id: 'PSG-903', symbol: 'PSG', name: 'Paris Saint-Germain Fan Token', network: 'Other' },
  { id: 'PSQON-1908', symbol: 'PSQON', name: 'ProShares Short QQQ Tokenized Stock (Ondo)', network: 'Other' },
  { id: 'PSTAKE-966', symbol: 'PSTAKE', name: 'pSTAKE Finance', network: 'Other' },
  { id: 'PTB-1781', symbol: 'PTB', name: 'Portal To Bitcoin', network: 'Bitcoin' },
  { id: 'PTU-927', symbol: 'PTU', name: 'Pintu Token', network: 'Other' },
  { id: 'PUBLIC-1721', symbol: 'PUBLIC', name: 'PublicAI', network: 'Other' },
  { id: 'PUFF-967', symbol: 'PUFF', name: 'Puff The Dragon', network: 'Other' },
  { id: 'PUFFER-968', symbol: 'PUFFER', name: 'Puffer', network: 'Other' },
  { id: 'PUMP-1512', symbol: 'PUMP', name: 'Pump.fun', network: 'Other' },
  { id: 'PUMPBTC-1619', symbol: 'PUMPBTC', name: 'PumpBTC', network: 'Other' },
  { id: 'PUNDIAI-971', symbol: 'PUNDIAI', name: 'PUNDI AI', network: 'Other' },
  { id: 'PUNDIX-972', symbol: 'PUNDIX', name: 'Pundi X (New)', network: 'Other' },
  { id: 'PURSE-973', symbol: 'PURSE', name: 'Pundi X PURSE', network: 'Other' },
  { id: 'PYR-1294', symbol: 'PYR', name: 'Vulcan Forged (PYR)', network: 'Other' },
  { id: 'PYTH-976', symbol: 'PYTH', name: 'Pyth Network', network: 'Other' },
  { id: 'PYUSD-909', symbol: 'PYUSD', name: 'PayPal USD', network: 'Other' },
  { id: 'Q-1722', symbol: 'Q', name: 'Quack AI', network: 'Other' },
  { id: 'QANX-1894', symbol: 'QANX', name: 'QANplatform', network: 'Other' },
  { id: 'QI-147', symbol: 'QI', name: 'BENQI', network: 'Other' },
  { id: 'QKC-982', symbol: 'QKC', name: 'QuarkChain', network: 'Other' },
  { id: 'QNT-981', symbol: 'QNT', name: 'Quant', network: 'Other' },
  { id: 'QORPO-979', symbol: 'QORPO', name: 'QORPO WORLD', network: 'Other' },
  { id: 'QQQON-1907', symbol: 'QQQON', name: 'Invesco QQQ Tokenized ETF (Ondo)', network: 'Other' },
  { id: 'QQQX-1536', symbol: 'QQQX', name: 'Nasdaq tokenized ETF', network: 'Other' },
  { id: 'QTUM-980', symbol: 'QTUM', name: 'Qtum', network: 'Other' },
  { id: 'QUBIC-983', symbol: 'QUBIC', name: 'Qubic', network: 'Other' },
  { id: 'QUICK-984', symbol: 'QUICK', name: 'QuickSwap (New)', network: 'Other' },
  { id: 'RACA-986', symbol: 'RACA', name: 'RACA', network: 'Other' },
  { id: 'RAD-988', symbol: 'RAD', name: 'Radworks', network: 'Other' },
  { id: 'RAI-1851', symbol: 'RAI', name: 'RAI Token', network: 'Other' },
  { id: 'RARE-1148', symbol: 'RARE', name: 'SuperRare', network: 'Other' },
  { id: 'RATS-992', symbol: 'RATS', name: 'rats (Ordinals)', network: 'Other' },
  { id: 'RAY-994', symbol: 'RAY', name: 'Raydium', network: 'Other' },
  { id: 'RCADE-1620', symbol: 'RCADE', name: 'RCADE Network', network: 'Other' },
  { id: 'RDAC-1621', symbol: 'RDAC', name: 'REDACTED', network: 'Other' },
  { id: 'RDNT-987', symbol: 'RDNT', name: 'Radiant Capital', network: 'Other' },
  { id: 'REACT-1866', symbol: 'REACT', name: 'Reactive Network', network: 'Other' },
  { id: 'RECALL-1834', symbol: 'RECALL', name: 'Recall', network: 'Other' },
  { id: 'RED-1422', symbol: 'RED', name: 'RedStone', network: 'Other' },
  { id: 'RED-1754', symbol: 'RED', name: 'RED', network: 'Other' },
  { id: 'REI-1003', symbol: 'REI', name: 'REI Network', network: 'Other' },
  { id: 'REN-1005', symbol: 'REN', name: 'Ren', network: 'Other' },
  { id: 'RENDER-1007', symbol: 'RENDER', name: 'Render', network: 'Other' },
  { id: 'RENEW-1745', symbol: 'RENEW', name: 'Renew', network: 'Other' },
  { id: 'REP-111', symbol: 'REP', name: 'Augur', network: 'Other' },
  { id: 'REQ-1010', symbol: 'REQ', name: 'Request', network: 'Other' },
  { id: 'RESOLV-1513', symbol: 'RESOLV', name: 'Resolv', network: 'Other' },
  { id: 'REX-1483', symbol: 'REX', name: 'REVOX', network: 'Other' },
  { id: 'REZ-1008', symbol: 'REZ', name: 'Renzo', network: 'Other' },
  { id: 'RFC-1482', symbol: 'RFC', name: 'Retard Finder Coin', network: 'Other' },
  { id: 'RIF-1025', symbol: 'RIF', name: 'Rootstock Infrastructure Framework', network: 'Other' },
  { id: 'RIO-995', symbol: 'RIO', name: 'Realio Network', network: 'Other' },
  { id: 'RION-1588', symbol: 'RION', name: 'Hyperion', network: 'Other' },
  { id: 'RIVER-1800', symbol: 'RIVER', name: 'River', network: 'Other' },
  { id: 'RLC-574', symbol: 'RLC', name: 'iExec RLC', network: 'Other' },
  { id: 'RLUSD-1970', symbol: 'RLUSD', name: 'Ripple USD', network: 'Ripple' },
  { id: 'RNBW-1969', symbol: 'RNBW', name: 'Rainbow', network: 'Other' },
  { id: 'ROAM-1423', symbol: 'ROAM', name: 'Roam', network: 'Other' },
  { id: 'ROBO-1976', symbol: 'ROBO', name: 'Fabric Protocol', network: 'Other' },
  { id: 'RON-1021', symbol: 'RON', name: 'Ronin', network: 'Other' },
  { id: 'ROOT-1192', symbol: 'ROOT', name: 'The Root Network', network: 'Other' },
  { id: 'ROSE-841', symbol: 'ROSE', name: 'Oasis Network', network: 'Other' },
  { id: 'RPL-1018', symbol: 'RPL', name: 'Rocket Pool', network: 'Other' },
  { id: 'RSR-1011', symbol: 'RSR', name: 'Reserve Rights', network: 'Other' },
  { id: 'RSS3-1030', symbol: 'RSS3', name: 'RSS3', network: 'Other' },
  { id: 'RUNE-1198', symbol: 'RUNE', name: 'THORChain', network: 'Other' },
  { id: 'RVM-997', symbol: 'RVM', name: 'Realvirm', network: 'Other' },
  { id: 'RVN-993', symbol: 'RVN', name: 'Ravencoin', network: 'Other' },
  { id: 'S-1103', symbol: 'S', name: 'Sonic', network: 'Other' },
  { id: 'SAFE-1036', symbol: 'SAFE', name: 'Safe', network: 'Other' },
  { id: 'SAGA-1039', symbol: 'SAGA', name: 'Saga', network: 'Other' },
  { id: 'SAHARA-1514', symbol: 'SAHARA', name: 'Sahara AI', network: 'Other' },
  { id: 'SAMO-1041', symbol: 'SAMO', name: 'Samoyedcoin', network: 'Other' },
  { id: 'SAND-1193', symbol: 'SAND', name: 'The Sandbox', network: 'Other' },
  { id: 'SANTOS-1043', symbol: 'SANTOS', name: 'Santos FC Fan Token', network: 'Other' },
  { id: 'SAPIEN-1723', symbol: 'SAPIEN', name: 'Sapien', network: 'Other' },
  { id: 'SAROS-1044', symbol: 'SAROS', name: 'Saros', network: 'Other' },
  { id: 'SATS-1046', symbol: 'SATS', name: 'SATS (Ordinals)', network: 'Other' },
  { id: 'SBETON-1967', symbol: 'SBETON', name: 'SharpLink Gaming, Inc Tokenized Stock (Ondo)', network: 'Other' },
  { id: 'SBUXON-1971', symbol: 'SBUXON', name: 'Starbucks Tokenized Stock (ONDO)', network: 'Other' },
  { id: 'SC-1069', symbol: 'SC', name: 'Siacoin', network: 'Other' },
  { id: 'SCA-1048', symbol: 'SCA', name: 'Scallop', network: 'Other' },
  { id: 'SCR-1049', symbol: 'SCR', name: 'Scroll', network: 'Other' },
  { id: 'SCRT-1360', symbol: 'SCRT', name: 'Secret', network: 'Other' },
  { id: 'SD-1115', symbol: 'SD', name: 'Stader', network: 'Other' },
  { id: 'SDEX-1084', symbol: 'SDEX', name: 'SmarDex', network: 'Other' },
  { id: 'SEI-1052', symbol: 'SEI', name: 'Sei', network: 'Other' },
  { id: 'SEILOR-636', symbol: 'SEILOR', name: 'Kryptonite', network: 'Other' },
  { id: 'SEND-1628', symbol: 'SEND', name: 'Suilend', network: 'Other' },
  { id: 'SENT-1915', symbol: 'SENT', name: 'Sentient', network: 'Other' },
  { id: 'SERAPH-1526', symbol: 'SERAPH', name: 'Seraph', network: 'Other' },
  { id: 'SFI-1038', symbol: 'SFI', name: 'Saffron.finance', network: 'Other' },
  { id: 'SFP-1037', symbol: 'SFP', name: 'SafePal', network: 'Other' },
  { id: 'SFUND-1051', symbol: 'SFUND', name: 'Seedify.fund', network: 'Other' },
  { id: 'SGOVON-1917', symbol: 'SGOVON', name: 'iShares 0-3 Month Treasury Bond Tokenized ETF (Ondo)', network: 'Other' },
  { id: 'SGT-1152', symbol: 'SGT', name: 'AI Avatar', network: 'Other' },
  { id: 'SHAN-1059', symbol: 'SHAN', name: 'Shanum', network: 'Other' },
  { id: 'SHELL-1424', symbol: 'SHELL', name: 'MyShell', network: 'Other' },
  { id: 'SHIB-1062', symbol: 'SHIB', name: 'SHIBA INU', network: 'Other' },
  { id: 'SHM-1624', symbol: 'SHM', name: 'Shardeum', network: 'Other' },
  { id: 'SHOW-1873', symbol: 'SHOW', name: 'SHOW', network: 'Other' },
  { id: 'SHRAP-1067', symbol: 'SHRAP', name: 'Shrapnel', network: 'Other' },
  { id: 'SHRED-1068', symbol: 'SHRED', name: 'ShredN', network: 'Other' },
  { id: 'SIDUS-1070', symbol: 'SIDUS', name: 'SIDUS', network: 'Other' },
  { id: 'SIGN-1484', symbol: 'SIGN', name: 'Sign', network: 'Other' },
  { id: 'SILO-1725', symbol: 'SILO', name: 'Silo Finance', network: 'Other' },
  { id: 'SIREN-1485', symbol: 'SIREN', name: 'SIREN', network: 'Other' },
  { id: 'SIS-1158', symbol: 'SIS', name: 'Symbiosis', network: 'Other' },
  { id: 'SKATE-1553', symbol: 'SKATE', name: 'Skate', network: 'Other' },
  { id: 'SKL-1077', symbol: 'SKL', name: 'SKALE', network: 'Other' },
  { id: 'SKR-1903', symbol: 'SKR', name: 'Solana Mobile Seeker', network: 'Solana' },
  { id: 'SKY-1078', symbol: 'SKY', name: 'Sky', network: 'Other' },
  { id: 'SKYA-1053', symbol: 'SKYA', name: 'Sekuya Multiverse', network: 'Other' },
  { id: 'SKYAI-1486', symbol: 'SKYAI', name: 'SKYAI', network: 'Other' },
  { id: 'SLERF-1081', symbol: 'SLERF', name: 'SLERF', network: 'Other' },
  { id: 'SLERFV2-1775', symbol: 'SLERFV2', name: 'SLERF v2', network: 'Other' },
  { id: 'SLF-1054', symbol: 'SLF', name: 'Self Chain', network: 'Other' },
  { id: 'SLIM-1095', symbol: 'SLIM', name: 'Solanium', network: 'Other' },
  { id: 'SLP-1091', symbol: 'SLP', name: 'Smooth Love Potion', network: 'Other' },
  { id: 'SLVON-1868', symbol: 'SLVON', name: 'iShares Silver Trust Tokenized ETF (Ondo)', network: 'Other' },
  { id: 'SMBT-1499', symbol: 'SMBT', name: 'SIMASByte Token', network: 'Other' },
  { id: 'SN-1744', symbol: 'SN', name: 'SpaceN', network: 'Other' },
  { id: 'SNAI-1680', symbol: 'SNAI', name: 'SwarmNode.ai', network: 'Other' },
  { id: 'SNEK-1092', symbol: 'SNEK', name: 'Snek', network: 'Other' },
  { id: 'SNS-1768', symbol: 'SNS', name: 'Solana Name Service', network: 'Solana' },
  { id: 'SNT-1126', symbol: 'SNT', name: 'Status', network: 'Other' },
  { id: 'SNX-1161', symbol: 'SNX', name: 'Synthetix', network: 'Other' },
  { id: 'SOL-1093', symbol: 'SOL', name: 'Solana', network: 'Solana' },
  { id: 'SOLAYER-1441', symbol: 'SOLAYER', name: 'Solayer', network: 'Other' },
  { id: 'SOLO-1100', symbol: 'SOLO', name: 'Sologenic', network: 'Other' },
  { id: 'SOLV-1425', symbol: 'SOLV', name: 'Solv Protocol', network: 'Other' },
  { id: 'SOMA-1886', symbol: 'SOMA', name: 'Soma Den', network: 'Other' },
  { id: 'SOMI-1726', symbol: 'SOMI', name: 'Somnia', network: 'Other' },
  { id: 'SONIC-1625', symbol: 'SONIC', name: 'SONIC SVM', network: 'Other' },
  { id: 'SOON-1516', symbol: 'SOON', name: 'SOON', network: 'Other' },
  { id: 'SOPHON-1517', symbol: 'SOPHON', name: 'Sophon', network: 'Other' },
  { id: 'SOSO-1426', symbol: 'SOSO', name: 'SoSoValue', network: 'Other' },
  { id: 'SPAB-1863', symbol: 'SPAB', name: 'Spacebyte', network: 'Other' },
  { id: 'SPACE-1983', symbol: 'SPACE', name: 'Spacecoin', network: 'Other' },
  { id: 'SPACEX-1991', symbol: 'SPACEX', name: 'SpaceX tokenized stock (PreStocks)', network: 'Other' },
  { id: 'SPEC-1109', symbol: 'SPEC', name: 'Spectral', network: 'Other' },
  { id: 'SPELL-1110', symbol: 'SPELL', name: 'Spell Token', network: 'Other' },
  { id: 'SPK-1527', symbol: 'SPK', name: 'Spark', network: 'Other' },
  { id: 'SPON-1679', symbol: 'SPON', name: 'Spheron Network', network: 'Other' },
  { id: 'SPOTON-1948', symbol: 'SPOTON', name: 'Spotify Tokenized Stock (Ondo)', network: 'Other' },
  { id: 'SPRK-1858', symbol: 'SPRK', name: 'Spark Equity', network: 'Other' },
  { id: 'SPURS-1216', symbol: 'SPURS', name: 'Tottenham Hotspur Fan Token', network: 'Other' },
  { id: 'SPX-1112', symbol: 'SPX', name: 'SPX6900', network: 'Other' },
  { id: 'SPYON-1910', symbol: 'SPYON', name: 'SPDR S&P 500 Tokenized ETF (Ondo)', network: 'Other' },
  { id: 'SPYX-1626', symbol: 'SPYX', name: 'SP500 tokenized ETF', network: 'Other' },
  { id: 'SQD-1141', symbol: 'SQD', name: 'Subsquid', network: 'Other' },
  { id: 'SQR-1711', symbol: 'SQR', name: 'magic square', network: 'Other' },
  { id: 'SQT-1140', symbol: 'SQT', name: 'SubQuery Network', network: 'Other' },
  { id: 'SRM-1058', symbol: 'SRM', name: 'Serum', network: 'Other' },
  { id: 'SRV-1727', symbol: 'SRV', name: 'SRIAVerse', network: 'Other' },
  { id: 'SSV-1113', symbol: 'SSV', name: 'ssv.network', network: 'Other' },
  { id: 'STABLE-1876', symbol: 'STABLE', name: 'Stable', network: 'Other' },
  { id: 'STBL-1786', symbol: 'STBL', name: 'STBL', network: 'Other' },
  { id: 'STBT-1543', symbol: 'STBT', name: 'Starbyte Token', network: 'Other' },
  { id: 'STEEM-1127', symbol: 'STEEM', name: 'Steem', network: 'Other' },
  { id: 'STETH-1427', symbol: 'STETH', name: 'Lido Staked Ether', network: 'Ethereum' },
  { id: 'STG-1120', symbol: 'STG', name: 'Stargate Finance', network: 'Other' },
  { id: 'STIK-1117', symbol: 'STIK', name: 'Staika', network: 'Other' },
  { id: 'STO-1489', symbol: 'STO', name: 'StakeStone', network: 'Other' },
  { id: 'STORJ-1132', symbol: 'STORJ', name: 'Storj', network: 'Other' },
  { id: 'STRAX-1135', symbol: 'STRAX', name: 'Xertra', network: 'Other' },
  { id: 'STREAM-1551', symbol: 'STREAM', name: 'Streamflow', network: 'Other' },
  { id: 'STRK-1122', symbol: 'STRK', name: 'Starknet', network: 'Other' },
  { id: 'STRM-1136', symbol: 'STRM', name: 'StreamCoin', network: 'Other' },
  { id: 'STX-1114', symbol: 'STX', name: 'Stacks', network: 'Other' },
  { id: 'SUI-1143', symbol: 'SUI', name: 'Sui', network: 'Other' },
  { id: 'SUN-1146', symbol: 'SUN', name: 'Sun [New]', network: 'Other' },
  { id: 'SUNBT-1730', symbol: 'SUNBT', name: 'SunByte', network: 'Other' },
  { id: 'SUNDOG-1147', symbol: 'SUNDOG', name: 'SUNDOG', network: 'Other' },
  { id: 'SUP-1731', symbol: 'SUP', name: 'Superp', network: 'Other' },
  { id: 'SUPER-1149', symbol: 'SUPER', name: 'SuperVerse', network: 'Other' },
  { id: 'SUPRA-1150', symbol: 'SUPRA', name: 'SUPRA', network: 'Other' },
  { id: 'SUSHI-1151', symbol: 'SUSHI', name: 'SushiSwap', network: 'Other' },
  { id: 'SVL-1079', symbol: 'SVL', name: 'Slash Vision Labs', network: 'Other' },
  { id: 'SWARMS-1629', symbol: 'SWARMS', name: 'Swarms', network: 'Other' },
  { id: 'SWCH-1156', symbol: 'SWCH', name: 'SwissCheese', network: 'Other' },
  { id: 'SWEAT-1154', symbol: 'SWEAT', name: 'Sweat Economy', network: 'Other' },
  { id: 'SWELL-1630', symbol: 'SWELL', name: 'Swell Network', network: 'Other' },
  { id: 'SWFTC-1155', symbol: 'SWFTC', name: 'SwftCoin', network: 'Other' },
  { id: 'SWTCH-1766', symbol: 'SWTCH', name: 'Switchboard Protocol', network: 'Other' },
  { id: 'SXP-1096', symbol: 'SXP', name: 'Solar', network: 'Other' },
  { id: 'SXT-1487', symbol: 'SXT', name: 'Space and Time', network: 'Other' },
  { id: 'SYMETRAX-1428', symbol: 'SYMETRAX', name: 'SymetraX', network: 'Other' },
  { id: 'SYN-1160', symbol: 'SYN', name: 'Synapse', network: 'Other' },
  { id: 'SYRUP-1445', symbol: 'SYRUP', name: 'Maple Finance', network: 'Other' },
  { id: 'SYS-1162', symbol: 'SYS', name: 'Syscoin', network: 'Other' },
  { id: 'T-1199', symbol: 'T', name: 'Threshold', network: 'Other' },
  { id: 'TA-1637', symbol: 'TA', name: 'Trusta.AI', network: 'Other' },
  { id: 'TAC-1632', symbol: 'TAC', name: 'TAC Protocol', network: 'Other' },
  { id: 'TAG-1633', symbol: 'TAG', name: 'Tagger', network: 'Other' },
  { id: 'TAI-1170', symbol: 'TAI', name: 'TARS AI', network: 'Other' },
  { id: 'TAIKO-1166', symbol: 'TAIKO', name: 'Taiko', network: 'Other' },
  { id: 'TAKE-1785', symbol: 'TAKE', name: 'Overtake', network: 'Other' },
  { id: 'TALE-1617', symbol: 'TALE', name: 'PrompTale AI', network: 'Other' },
  { id: 'TANSSI-1634', symbol: 'TANSSI', name: 'Tanssi', network: 'Other' },
  { id: 'TAO-175', symbol: 'TAO', name: 'Bittensor', network: 'Other' },
  { id: 'TCOM-1732', symbol: 'TCOM', name: 'TCOM Global', network: 'Other' },
  { id: 'TEL-1172', symbol: 'TEL', name: 'Telcoin', network: 'Other' },
  { id: 'TEN-1207', symbol: 'TEN', name: 'Tokenomy', network: 'Other' },
  { id: 'TEST-1442', symbol: 'TEST', name: 'TEST', network: 'Other' },
  { id: 'TFUEL-1195', symbol: 'TFUEL', name: 'Theta Fuel', network: 'Other' },
  { id: 'THE-1194', symbol: 'THE', name: 'Thena', network: 'Other' },
  { id: 'THETA-1196', symbol: 'THETA', name: 'Theta Network', network: 'Other' },
  { id: 'TIA-238', symbol: 'TIA', name: 'Celestia', network: 'Other' },
  { id: 'TIME-1566', symbol: 'TIME', name: 'Chrono.tech', network: 'Other' },
  { id: 'TKO-1209', symbol: 'TKO', name: 'Toko Token', network: 'Other' },
  { id: 'TLM-47', symbol: 'TLM', name: 'Alien Worlds', network: 'Other' },
  { id: 'TLOS-1175', symbol: 'TLOS', name: 'Telos', network: 'Other' },
  { id: 'TLTON-1913', symbol: 'TLTON', name: 'iShares 20+ Year Treasury Bond Tokenized ETF (Ondo)', network: 'Other' },
  { id: 'TMG-1163', symbol: 'TMG', name: 'T-mac DAO', network: 'Other' },
  { id: 'TMON-1955', symbol: 'TMON', name: 'Toyota Tokenized Stock (Ondo)', network: 'Other' },
  { id: 'TNSR-1178', symbol: 'TNSR', name: 'Tensor', network: 'Other' },
  { id: 'TOKAMAK-1203', symbol: 'TOKAMAK', name: 'Tokamak Network', network: 'Other' },
  { id: 'TOKEN-1205', symbol: 'TOKEN', name: 'TokenFi', network: 'Other' },
  { id: 'TOKO-1210', symbol: 'TOKO', name: 'Tokoin', network: 'Other' },
  { id: 'TOMA-1635', symbol: 'TOMA', name: 'Tomarket', network: 'Other' },
  { id: 'TON-1213', symbol: 'TON', name: 'Toncoin', network: 'Other' },
  { id: 'TOSHI-1215', symbol: 'TOSHI', name: 'Toshi', network: 'Other' },
  { id: 'TOWN-1689', symbol: 'TOWN', name: 'Alt.town', network: 'Other' },
  { id: 'TOWNS-1734', symbol: 'TOWNS', name: 'Towns', network: 'Other' },
  { id: 'TQQQON-1906', symbol: 'TQQQON', name: 'ProShares UltraPro QQQ Tokenized Stock (Ondo)', network: 'Other' },
  { id: 'TQQQX-1735', symbol: 'TQQQX', name: 'TQQQ tokenized ETF stock', network: 'Other' },
  { id: 'TRAC-1611', symbol: 'TRAC', name: 'OriginTrail', network: 'Other' },
  { id: 'TRADOOR-1993', symbol: 'TRADOOR', name: 'Tradoor', network: 'Other' },
  { id: 'TRB-1174', symbol: 'TRB', name: 'Tellor', network: 'Other' },
  { id: 'TREAT-1636', symbol: 'TREAT', name: 'Treat', network: 'Other' },
  { id: 'TREE-1681', symbol: 'TREE', name: 'Treehouse', network: 'Other' },
  { id: 'TRIA-1936', symbol: 'TRIA', name: 'Tria', network: 'Other' },
  { id: 'TROLL-1222', symbol: 'TROLL', name: 'Troll', network: 'Other' },
  { id: 'TROLL-1490', symbol: 'TROLLSOL', name: 'TROLL (SOL)', network: 'Other' },
  { id: 'TRU-1225', symbol: 'TRU', name: 'TrueFi', network: 'Other' },
  { id: 'TRUMP-1429', symbol: 'TRUMP', name: 'OFFICIAL TRUMP', network: 'Other' },
  { id: 'TRUST-1823', symbol: 'TRUST', name: 'Intuition', network: 'Other' },
  { id: 'TRUU-1780', symbol: 'TRUU', name: 'Truth', network: 'Other' },
  { id: 'TRVL-1573', symbol: 'TRVL', name: 'Dtravel', network: 'Other' },
  { id: 'TRX-1223', symbol: 'TRX', name: 'TRON', network: 'Tron' },
  { id: 'TSLAON-1945', symbol: 'TSLAON', name: 'Tesla Tokenized Stock (Ondo)', network: 'Other' },
  { id: 'TSLAX-1539', symbol: 'TSLAX', name: 'Tesla tokenized stock', network: 'Other' },
  { id: 'TUNA-1837', symbol: 'TUNA', name: 'DefiTuna', network: 'Other' },
  { id: 'TURBO-1229', symbol: 'TURBO', name: 'Turbo', network: 'Other' },
  { id: 'TURBOS-1230', symbol: 'TURBOS', name: 'Turbos Finance', network: 'Other' },
  { id: 'TURTLE-1810', symbol: 'TURTLE', name: 'Turtle', network: 'Other' },
  { id: 'TUSD-1226', symbol: 'TUSD', name: 'TrueUSD', network: 'Ethereum' },
  { id: 'TUT-1518', symbol: 'TUT', name: 'Tutorial', network: 'Other' },
  { id: 'TWELVE-1232', symbol: 'TWELVE', name: 'Twelve Zodiac', network: 'Other' },
  { id: 'TWT-1227', symbol: 'TWT', name: 'Trust Wallet Token', network: 'Other' },
  { id: 'TX-1979', symbol: 'TX', name: 'tx', network: 'Other' },
  { id: 'U-1763', symbol: 'UNION', name: 'Union', network: 'Other' },
  { id: 'U-1889', symbol: 'U', name: 'United Stables', network: 'Other' },
  { id: 'U2U-1638', symbol: 'U2U', name: 'U2U Network', network: 'Other' },
  { id: 'UAI-1862', symbol: 'UAI', name: 'UnifAI Network', network: 'Other' },
  { id: 'UB-1831', symbol: 'UB', name: 'Unibase', network: 'Other' },
  { id: 'UCJL-1368', symbol: 'UCJL', name: 'Utility Cjournal', network: 'Other' },
  { id: 'ULTI-1235', symbol: 'ULTI', name: 'Ultiverse', network: 'Other' },
  { id: 'UMA-1236', symbol: 'UMA', name: 'UMA', network: 'Other' },
  { id: 'UNHON-1854', symbol: 'UNHON', name: 'UNITEDHEALTH TOKENIZED STOCK (ONDO)', network: 'Other' },
  { id: 'UNI-1245', symbol: 'UNI', name: 'Uniswap', network: 'Other' },
  { id: 'UNITE-1682', symbol: 'UNITE', name: 'Unite', network: 'Other' },
  { id: 'UNMD-1369', symbol: 'UNMD', name: 'Utility Nexusmind', network: 'Other' },
  { id: 'URAON-1989', symbol: 'URAON', name: 'Global X Uranium Tokenized ETF (Ondo)', network: 'Other' },
  { id: 'USAT-1973', symbol: 'USAT', name: 'USAT', network: 'Other' },
  { id: 'USD1-1491', symbol: 'USD1', name: 'USD1', network: 'Other' },
  { id: 'USDC-1252', symbol: 'USDC', name: 'USDC', network: 'Ethereum' },
  { id: 'USDD-1640', symbol: 'USDD', name: 'USDD', network: 'Ethereum' },
  { id: 'USDE-417', symbol: 'USDE', name: 'Ethena USDe', network: 'Other' },
  { id: 'USDG-1500', symbol: 'USDG', name: 'Global Dollar', network: 'Other' },
  { id: 'USDGO-1987', symbol: 'USDGO', name: 'USDGO', network: 'Other' },
  { id: 'USDP-906', symbol: 'USDP', name: 'Pax Dollar', network: 'Ethereum' },
  { id: 'USDR-1488', symbol: 'USDR', name: 'StablR USD', network: 'Other' },
  { id: 'USDS-1253', symbol: 'USDS', name: 'USDS', network: 'Other' },
  { id: 'USDT-1187', symbol: 'USDT', name: 'Tether USDt', network: 'Ethereum' },
  { id: 'USDTB-1581', symbol: 'USDTB', name: 'Ethena Labs (USDTB)', network: 'Other' },
  { id: 'USDY-1609', symbol: 'USDY', name: 'Ondo US Dollar Yield', network: 'Other' },
  { id: 'USELESS-1519', symbol: 'USELESS', name: 'Useless Coin', network: 'Other' },
  { id: 'USFRON-1914', symbol: 'USFRON', name: 'WisdomTree Floating Rate Treasury Tokenized Fund (Ondo)', network: 'Other' },
  { id: 'USOON-1918', symbol: 'USOON', name: 'United States Oil Tokenized Fund (Ondo)', network: 'Other' },
  { id: 'USTC-1184', symbol: 'USTC', name: 'TerraClassicUSD', network: 'Other' },
  { id: 'USUAL-1431', symbol: 'USUAL', name: 'Usual', network: 'Other' },
  { id: 'UTK-1334', symbol: 'UTK', name: 'xMoney', network: 'Other' },
  { id: 'UW3S-1254', symbol: 'UW3S', name: 'Utility Web3Shot', network: 'Other' },
  { id: 'VAI-1257', symbol: 'VAI', name: 'VAIOT', network: 'Other' },
  { id: 'VAL-1370', symbol: 'VAL', name: 'Validity', network: 'Other' },
  { id: 'VANA-1432', symbol: 'VANA', name: 'Vana', network: 'Other' },
  { id: 'VANRY-1258', symbol: 'VANRY', name: 'Vanar Chain', network: 'Other' },
  { id: 'VBG-1277', symbol: 'VBG', name: 'Vibing', network: 'Other' },
  { id: 'VCG-1261', symbol: 'VCG', name: 'VCGamers', network: 'Other' },
  { id: 'VELO-1264', symbol: 'VELO', name: 'Velo', network: 'Other' },
  { id: 'VELOFIN-1266', symbol: 'VELOFIN', name: 'Velodrome Finance', network: 'Other' },
  { id: 'VELVET-1642', symbol: 'VELVET', name: 'Velvet', network: 'Other' },
  { id: 'VENOM-1268', symbol: 'VENOM', name: 'Venom', network: 'Other' },
  { id: 'VERT-1643', symbol: 'VERT', name: 'Vertus', network: 'Other' },
  { id: 'VET-1262', symbol: 'VET', name: 'VeChain', network: 'Other' },
  { id: 'VEX-1275', symbol: 'VEX', name: 'Vexanium', network: 'Other' },
  { id: 'VFY-1788', symbol: 'VFY', name: 'zkVerify', network: 'Other' },
  { id: 'VIC-1278', symbol: 'VIC', name: 'Viction', network: 'Other' },
  { id: 'VINE-1520', symbol: 'VINE', name: 'Vine Coin', network: 'Other' },
  { id: 'VINU-1286', symbol: 'VINU', name: 'Vita Inu', network: 'Other' },
  { id: 'VIRTUAL-1285', symbol: 'VIRTUAL', name: 'Virtuals Protocol', network: 'Other' },
  { id: 'VOLT-1290', symbol: 'VOLT', name: 'Volt Inu', network: 'Other' },
  { id: 'VON-1947', symbol: 'VON', name: 'Visa Tokenized Stock (Ondo)', network: 'Other' },
  { id: 'VOXEL-1292', symbol: 'VOXEL', name: 'Voxies', network: 'Other' },
  { id: 'VR-1279', symbol: 'VR', name: 'Victoria VR', network: 'Other' },
  { id: 'VRA-1270', symbol: 'VRA', name: 'Verasity', network: 'Other' },
  { id: 'VSN-1644', symbol: 'VSN', name: 'Vision', network: 'Other' },
  { id: 'VSYS-1256', symbol: 'VSYS', name: 'V.SYSTEMS', network: 'Other' },
  { id: 'VTHO-1274', symbol: 'VTHO', name: 'VeThor Token', network: 'Other' },
  { id: 'VTIX-1940', symbol: 'VTIX', name: 'Vanguard tokenized ETF (xStock)', network: 'Other' },
  { id: 'VVV-1492', symbol: 'VVV', name: 'Venice Token', network: 'Other' },
  { id: 'W-1318', symbol: 'W', name: 'Wormhole', network: 'Other' },
  { id: 'W3F-1304', symbol: 'W3F', name: 'Web3Frontier', network: 'Other' },
  { id: 'W3S-1434', symbol: 'W3S', name: 'Web3Shot', network: 'Other' },
  { id: 'WAGMIGAMES-1296', symbol: 'WAGMIGAMES', name: 'WAGMI Games', network: 'Other' },
  { id: 'WAI-1740', symbol: 'WAI', name: 'World3', network: 'Other' },
  { id: 'WAL-1493', symbol: 'WAL', name: 'Walrus', network: 'Other' },
  { id: 'WAN-1299', symbol: 'WAN', name: 'Wanchain', network: 'Other' },
  { id: 'WAVES-1301', symbol: 'WAVES', name: 'Waves', network: 'Other' },
  { id: 'WAXP-1302', symbol: 'WAXP', name: 'WAX', network: 'Other' },
  { id: 'WBETH-1320', symbol: 'WBETH', name: 'Wrapped Beacon ETH', network: 'Ethereum' },
  { id: 'WBT-1308', symbol: 'WBT', name: 'WhiteBIT Coin', network: 'Other' },
  { id: 'WBTC-1321', symbol: 'WBTC', name: 'Wrapped Bitcoin', network: 'Bitcoin' },
  { id: 'WCT-1435', symbol: 'WCT', name: 'WalletConnect', network: 'Other' },
  { id: 'WEALTH-1934', symbol: 'WEALTH', name: 'Wealth Crypto', network: 'Other' },
  { id: 'WEMIX-1305', symbol: 'WEMIX', name: 'WEMIX', network: 'Other' },
  { id: 'WEN-1306', symbol: 'WEN', name: 'WEN', network: 'Other' },
  { id: 'WET-1877', symbol: 'WET', name: 'HumidiFi', network: 'Other' },
  { id: 'WHITEWHALE-1895', symbol: 'WHITEWHALE', name: 'The White Whale', network: 'Other' },
  { id: 'WHY-1373', symbol: 'WHY', name: 'WHY', network: 'Other' },
  { id: 'WIF-368', symbol: 'WIF', name: 'dogwifhat', network: 'Other' },
  { id: 'WILD-1309', symbol: 'WILD', name: 'Wilder World', network: 'Other' },
  { id: 'WIN-1311', symbol: 'WIN', name: 'WINkLink', network: 'Other' },
  { id: 'WING-1310', symbol: 'WING', name: 'Wing Finance', network: 'Other' },
  { id: 'WLD-1316', symbol: 'WLD', name: 'Worldcoin', network: 'Other' },
  { id: 'WLFI-1739', symbol: 'WLFI', name: 'World Liberty Financial', network: 'Other' },
  { id: 'WNXM-1322', symbol: 'WNXM', name: 'Wrapped NXM', network: 'Other' },
  { id: 'WOLF-1593', symbol: 'WOLF', name: 'LandwolfSOL', network: 'Other' },
  { id: 'WOO-1314', symbol: 'WOO', name: 'WOO', network: 'Other' },
  { id: 'WOZX-393', symbol: 'WOZX', name: 'Efforce', network: 'Other' },
  { id: 'WTEC-1315', symbol: 'WTEC', name: 'World Trade Exhibition Center', network: 'Other' },
  { id: 'WUSD-1317', symbol: 'WUSD', name: 'Worldwide USD', network: 'Other' },
  { id: 'WXT-1737', symbol: 'WXT', name: 'WEEX Token', network: 'Other' },
  { id: 'X-1324', symbol: 'X', name: 'X Empire', network: 'Other' },
  { id: 'XAI-1326', symbol: 'XAI', name: 'Xai', network: 'Other' },
  { id: 'XAN-1791', symbol: 'XAN', name: 'Anoma', network: 'Other' },
  { id: 'XAUT-1186', symbol: 'XAUT', name: 'Tether Gold', network: 'Other' },
  { id: 'XCAD-1328', symbol: 'XCAD', name: 'XCAD Network', network: 'Other' },
  { id: 'XCH-252', symbol: 'XCH', name: 'Chia', network: 'Other' },
  { id: 'XCN-864', symbol: 'XCN', name: 'Onyxcoin', network: 'Other' },
  { id: 'XDC-1330', symbol: 'XDC', name: 'XDC Network', network: 'Other' },
  { id: 'XEC-387', symbol: 'XEC', name: 'eCash', network: 'Other' },
  { id: 'XEM-806', symbol: 'XEM', name: 'NEM', network: 'Other' },
  { id: 'XEN-1331', symbol: 'XEN', name: 'XEN Crypto', network: 'Other' },
  { id: 'XGD-1371', symbol: 'XGD', name: 'XGold', network: 'Other' },
  { id: 'XLM-1130', symbol: 'XLM', name: 'Stellar', network: 'Other' },
  { id: 'XMN-1986', symbol: 'XMN', name: 'xMoney', network: 'Other' },
  { id: 'XNO-798', symbol: 'XNO', name: 'Nano', network: 'Other' },
  { id: 'XNY-1696', symbol: 'XNY', name: 'Codatta', network: 'Other' },
  { id: 'XO-1647', symbol: 'XO', name: 'XOCIETY', network: 'Other' },
  { id: 'XOMON-1944', symbol: 'XOMON', name: 'Exxon Mobile Tokenized Stock (Ondo)', network: 'Other' },
  { id: 'XPL-1719', symbol: 'XPL', name: 'Plasma', network: 'Other' },
  { id: 'XPR-1337', symbol: 'XPR', name: 'XPR Network', network: 'Other' },
  { id: 'XR-1338', symbol: 'XR', name: 'XRADERS', network: 'Other' },
  { id: 'XRP-1339', symbol: 'XRP', name: 'XRP', network: 'Ripple' },
  { id: 'XTER-1648', symbol: 'XTER', name: 'Xterio', network: 'Other' },
  { id: 'XTZ-1188', symbol: 'XTZ', name: 'Tezos', network: 'Other' },
  { id: 'XUSD-1436', symbol: 'XUSD', name: 'StraisxUSD', network: 'Other' },
  { id: 'XVG-1271', symbol: 'XVG', name: 'Verge', network: 'Other' },
  { id: 'XVS-1269', symbol: 'XVS', name: 'Venus', network: 'BNB SmartChain' },
  { id: 'XYO-1741', symbol: 'XYO', name: 'XYO Network', network: 'Other' },
  { id: 'YB-1801', symbol: 'YB', name: 'Yield Basis', network: 'Other' },
  { id: 'YFI-1342', symbol: 'YFI', name: 'yearn.finance', network: 'Other' },
  { id: 'YFII-347', symbol: 'YFII', name: 'DFI.Money', network: 'Other' },
  { id: 'YGG-1343', symbol: 'YGG', name: 'Yield Guild Games', network: 'Other' },
  { id: 'YZY-1742', symbol: 'YZY', name: 'YZY MONEY', network: 'Other' },
  { id: 'ZAMA-1929', symbol: 'ZAMA', name: 'Zama', network: 'Other' },
  { id: 'ZBCN-1346', symbol: 'ZBCN', name: 'Zebec Network', network: 'Other' },
  { id: 'ZBT-1807', symbol: 'ZBT', name: 'Zerobase', network: 'Other' },
  { id: 'ZBU-1347', symbol: 'ZBU', name: 'Zeebu', network: 'Other' },
  { id: 'ZCX-1246', symbol: 'ZCX', name: 'Unizen', network: 'Other' },
  { id: 'ZEN-1587', symbol: 'ZEN', name: 'Horizen', network: 'Other' },
  { id: 'ZENT-1348', symbol: 'ZENT', name: 'Zentry', network: 'Other' },
  { id: 'ZEREBRO-1349', symbol: 'ZEREBRO', name: 'Zerebro', network: 'Other' },
  { id: 'ZERO-1351', symbol: 'ZERO', name: 'ZeroLend', network: 'Other' },
  { id: 'ZETA-1353', symbol: 'ZETA', name: 'ZetaChain', network: 'Other' },
  { id: 'ZEUS-1354', symbol: 'ZEUS', name: 'Zeus Network', network: 'Other' },
  { id: 'ZEX-1352', symbol: 'ZEX', name: 'ZETA', network: 'Other' },
  { id: 'ZIG-1651', symbol: 'ZIG', name: 'ZIGChain', network: 'Other' },
  { id: 'ZIL-1355', symbol: 'ZIL', name: 'Zilliqa', network: 'Other' },
  { id: 'ZK-1437', symbol: 'ZK', name: 'ZkSync', network: 'Other' },
  { id: 'ZKC-1770', symbol: 'ZKC', name: 'Boundless', network: 'Other' },
  { id: 'ZKJ-947', symbol: 'ZKJ', name: 'Polyhedra Network', network: 'Other' },
  { id: 'ZKL-1652', symbol: 'ZKL', name: 'zkLink', network: 'Other' },
  { id: 'ZKP-1900', symbol: 'ZKP', name: 'zkPass', network: 'Other' },
  { id: 'ZKWASM-1743', symbol: 'ZKWASM', name: 'ZKWASM', network: 'Other' },
  { id: 'ZORA-1494', symbol: 'ZORA', name: 'Zora', network: 'Other' },
  { id: 'ZRC-1524', symbol: 'ZRC', name: 'Zircuit', network: 'Other' },
  { id: 'ZRO-1438', symbol: 'ZRO', name: 'LayerZero', network: 'Other' },
  { id: 'ZRX-2', symbol: 'ZRX', name: '0x Protocol', network: 'Other' },
  { id: 'ZTC-1902', symbol: 'ZTC', name: 'ZenChain', network: 'Other' },
  { id: 'IDRP-3123', symbol: 'IDRP', name: 'IDRP', network: 'Tron' },
  { id: 'IDRP-3124', symbol: 'IDRP', name: 'IDRP', network: 'Polygon' },
  { id: 'IDRP-3125', symbol: 'IDRP', name: 'IDRP', network: 'Kaia' },
  { id: 'IDRP-3126', symbol: 'IDRP', name: 'IDRP', network: 'BNB SmartChain' },
  { id: 'IDRP-3127', symbol: 'IDRP', name: 'IDRP', network: 'Ethereum' },
];
